export const LOCAL_PUZZLES_DB = [
    {
        "PuzzleId": "001gi",
        "FEN": "r6r/1pNk1ppp/2np4/b3p3/4P1b1/N1Q5/P4PPP/R3KB1R w KQ - 3 18",
        "Moves": "c7a8 a5c3",
        "Rating": 845,
        "RatingDeviation": 122,
        "Popularity": 61,
        "NbPlays": 210,
        "Themes": "bodenMate hangingPiece mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/1sV2Hr22#34",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Other_variations"
    },
    {
        "PuzzleId": "001wb",
        "FEN": "r3k2r/pb1p1ppp/1b4q1/1Q2P3/8/2NP1Pn1/PP4PP/R1B2R1K w kq - 1 17",
        "Moves": "h2g3 g6h5",
        "Rating": 1520,
        "RatingDeviation": 162,
        "Popularity": 72,
        "NbPlays": 53,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/hNzYRMWP#32",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Bird_Variation"
    },
    {
        "PuzzleId": "002CP",
        "FEN": "r5k1/pp4pp/4p1q1/4p3/3n4/P5P1/1PP2Q1P/2KR1R2 w - - 4 24",
        "Moves": "f2e3 g6c2",
        "Rating": 929,
        "RatingDeviation": 80,
        "Popularity": 69,
        "NbPlays": 82,
        "Themes": "endgame mate mateIn1 oneMove queensideAttack",
        "GameUrl": "https://lichess.org/pHZnIFdb#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003IX",
        "FEN": "8/3pk3/R7/1R2Pp1p/2PPnKr1/8/8/8 w - - 4 43",
        "Moves": "f4f5 e4g3",
        "Rating": 1726,
        "RatingDeviation": 84,
        "Popularity": 88,
        "NbPlays": 1133,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/576Btq56#84",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004JD",
        "FEN": "3r4/R7/2p5/p1P2p2/1p4k1/nP6/P2KNP2/8 w - - 3 41",
        "Moves": "d2e3 a3c2",
        "Rating": 1336,
        "RatingDeviation": 76,
        "Popularity": 91,
        "NbPlays": 2543,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/6vTeEc3x#80",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004iZ",
        "FEN": "r2r2k1/2q1bpp1/3p1n1p/1ppN4/1P1BP3/P5Q1/4RPPP/R5K1 b - - 1 20",
        "Moves": "f6d5 g3g7",
        "Rating": 570,
        "RatingDeviation": 90,
        "Popularity": 89,
        "NbPlays": 883,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/dQ85JUe1/black#39",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004zI",
        "FEN": "2q3k1/4br1p/6RQ/1p1n2p1/7P/1P4P1/1B2PP2/6K1 b - - 0 27",
        "Moves": "h7g6 h6h8",
        "Rating": 1423,
        "RatingDeviation": 75,
        "Popularity": 79,
        "NbPlays": 312,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/HE33gdt4/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "007c6",
        "FEN": "2kr3r/pp1n2pp/2QB1bp1/5q2/2B5/8/PPP2PPP/3R1RK1 b - - 0 17",
        "Moves": "b7c6 c4a6",
        "Rating": 723,
        "RatingDeviation": 79,
        "Popularity": 56,
        "NbPlays": 151,
        "Themes": "bodenMate mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/vqwzqZHC/black#33",
        "OpeningTags": "Elephant_Gambit Elephant_Gambit_Other_variations"
    },
    {
        "PuzzleId": "007fJ",
        "FEN": "8/1P3ppp/8/8/8/2pk3P/3p2P1/3K4 w - - 0 52",
        "Moves": "b7b8q c3c2",
        "Rating": 616,
        "RatingDeviation": 80,
        "Popularity": 100,
        "NbPlays": 117,
        "Themes": "advancedPawn endgame mate mateIn1 oneMove queenEndgame",
        "GameUrl": "https://lichess.org/34ezZi7R#102",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008LD",
        "FEN": "8/6pp/4N1k1/5p2/5P2/5rPb/4R2P/6K1 w - - 0 35",
        "Moves": "e6g5 f3f1",
        "Rating": 461,
        "RatingDeviation": 88,
        "Popularity": 100,
        "NbPlays": 139,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/jzHHsjDp#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008Nz",
        "FEN": "6k1/2p2ppp/pnp5/B7/2P3PP/1P1bPPR1/r6r/3R2K1 b - - 1 29",
        "Moves": "d3e2 d1d8",
        "Rating": 457,
        "RatingDeviation": 99,
        "Popularity": 84,
        "NbPlays": 883,
        "Themes": "backRankMate mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/HNU4zavC/black#57",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008o6",
        "FEN": "Q5k1/p1p3p1/5rP1/8/3P4/7P/q3r3/B4RK1 b - - 1 34",
        "Moves": "f6f8 a8f8",
        "Rating": 471,
        "RatingDeviation": 87,
        "Popularity": 75,
        "NbPlays": 117,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/1k4lXfEi/black#67",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009L0",
        "FEN": "6k1/pb2r1pN/1n4Bp/3p4/1P2pR2/P7/3R1PPP/2r3K1 w - - 2 30",
        "Moves": "d2d1 c1d1",
        "Rating": 706,
        "RatingDeviation": 146,
        "Popularity": 18,
        "NbPlays": 22,
        "Themes": "backRankMate hangingPiece mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/SAhQtou2#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00AGs",
        "FEN": "rn2k2Q/5p2/2p1p1r1/1q4p1/8/8/4NPPP/3R1K1R b q - 5 23",
        "Moves": "e8e7 h8d8",
        "Rating": 849,
        "RatingDeviation": 81,
        "Popularity": 93,
        "NbPlays": 368,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/gBoWCcF2/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00B2k",
        "FEN": "r4rk1/pbp3pp/1p1pp3/6B1/2PPp2q/3nP2P/PP3P2/R2QKBR1 w Q - 8 16",
        "Moves": "f1d3 h4f2",
        "Rating": 833,
        "RatingDeviation": 130,
        "Popularity": 43,
        "NbPlays": 17,
        "Themes": "attackingF2F7 mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/SIYAVKzo#30",
        "OpeningTags": "Dutch_Defense Dutch_Defense_Queens_Knight_Variation"
    },
    {
        "PuzzleId": "00Bm8",
        "FEN": "8/6kp/4b1q1/1p6/1PpPp2Q/2P1P3/r2N2P1/5RK1 w - - 7 34",
        "Moves": "d2e4 g6g2",
        "Rating": 1126,
        "RatingDeviation": 76,
        "Popularity": 86,
        "NbPlays": 324,
        "Themes": "endgame master mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/ynNNLRgG#66",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00C7m",
        "FEN": "8/5k2/1P4R1/6PK/1r6/8/8/8 w - - 1 58",
        "Moves": "h5h6 b4h4",
        "Rating": 755,
        "RatingDeviation": 119,
        "Popularity": 67,
        "NbPlays": 56,
        "Themes": "endgame mate mateIn1 oneMove rookEndgame",
        "GameUrl": "https://lichess.org/ZbuTrTYp#114",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00DPQ",
        "FEN": "2k4r/pp3pp1/4pn2/2np2p1/8/1B1P1Pq1/PPPN1R2/R2Q3K w - - 6 20",
        "Moves": "f2h2 g3h2",
        "Rating": 769,
        "RatingDeviation": 96,
        "Popularity": 84,
        "NbPlays": 108,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/AKiNfVd0#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00DU5",
        "FEN": "r1bq1rk1/5ppp/p2p1b2/1p1Pn3/1P2Q3/P1NB3P/1B3PP1/R4RK1 b - - 2 17",
        "Moves": "c8b7 e4h7",
        "Rating": 511,
        "RatingDeviation": 86,
        "Popularity": 78,
        "NbPlays": 84,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/sDwtQGBU/black#33",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Delayed_Alapin_Variation"
    },
    {
        "PuzzleId": "00DWo",
        "FEN": "b4b1r/3k1ppp/p2p4/1p2p3/3nq3/N1P1B3/PP3PPP/R2Q1RK1 w - - 1 16",
        "Moves": "c3d4 e4g2",
        "Rating": 1063,
        "RatingDeviation": 105,
        "Popularity": 82,
        "NbPlays": 38,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/bSwKB2bL#30",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Kalashnikov_Variation"
    },
    {
        "PuzzleId": "00FHX",
        "FEN": "2r3k1/5p1p/4pP2/3p3P/8/5P2/p1b3P1/2R3K1 b - - 0 30",
        "Moves": "c2b1 c1c8",
        "Rating": 532,
        "RatingDeviation": 94,
        "Popularity": 84,
        "NbPlays": 714,
        "Themes": "endgame hangingPiece mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/rztVgThB/black#59",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00FjB",
        "FEN": "rnbk3r/pppp1Bpp/8/5p2/4p3/2PP4/P1P2PPP/R1B1K2R b KQ - 0 13",
        "Moves": "h8f8 c1g5",
        "Rating": 885,
        "RatingDeviation": 146,
        "Popularity": 59,
        "NbPlays": 168,
        "Themes": "doubleBishopMate mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/r1BPO2dx/black#25",
        "OpeningTags": "Bishops_Opening Bishops_Opening_Boden-Kieseritzky_Gambit"
    },
    {
        "PuzzleId": "00G0z",
        "FEN": "Q4n1k/p2b2pp/3b4/2p5/4pq2/2Pn3P/PP1NBPP1/R1B2RK1 w - - 1 23",
        "Moves": "d2e4 f4h2",
        "Rating": 1339,
        "RatingDeviation": 93,
        "Popularity": 29,
        "NbPlays": 53,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/5yn9tO6O#44",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GRa",
        "FEN": "1r3rk1/2p1Nppb/p2nq3/1p2p1Pp/4Qn1P/2P1N3/PPB2P1K/3R2R1 b - - 5 28",
        "Moves": "e6e7 e4h7",
        "Rating": 465,
        "RatingDeviation": 96,
        "Popularity": 95,
        "NbPlays": 817,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/QiJhfG8J/black#55",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GY4",
        "FEN": "3k2r1/pR5R/3r4/4p1q1/7Q/3Pn1PP/PP5K/8 b - - 0 27",
        "Moves": "g5h4 b7b8",
        "Rating": 1205,
        "RatingDeviation": 85,
        "Popularity": 100,
        "NbPlays": 46,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/uDdpetkC/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00H1C",
        "FEN": "r3r3/1kpRnqpp/p4p2/Qp2P2P/1N6/4Pb2/PPP3P1/2K2R2 b - - 0 22",
        "Moves": "e7c6 a5c7",
        "Rating": 1528,
        "RatingDeviation": 76,
        "Popularity": 90,
        "NbPlays": 1151,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/GzcjOw0p/black#43",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00H9n",
        "FEN": "7k/6p1/8/4p3/Pp1b4/1P3b1q/3Q2P1/5RK1 w - - 0 45",
        "Moves": "d2d4 h3g2",
        "Rating": 878,
        "RatingDeviation": 76,
        "Popularity": 90,
        "NbPlays": 297,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/MaGCLflH#88",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HHN",
        "FEN": "4r2k/p6p/1p3R2/2p5/2P5/1P4R1/r5PP/2K5 w - - 0 32",
        "Moves": "f6f7 e8e1",
        "Rating": 491,
        "RatingDeviation": 85,
        "Popularity": 98,
        "NbPlays": 577,
        "Themes": "endgame mate mateIn1 oneMove rookEndgame",
        "GameUrl": "https://lichess.org/tMmxk7ja#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HPz",
        "FEN": "6r1/7p/2pk1p2/P2p4/P2KbP2/4P3/4NR1P/8 w - - 1 35",
        "Moves": "e2c3 c6c5",
        "Rating": 681,
        "RatingDeviation": 85,
        "Popularity": 95,
        "NbPlays": 569,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/ElfQqRYp#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HnR",
        "FEN": "q5kr/p4p2/3Bb1p1/4p2p/5n2/2P5/P1Q2PPP/3R1RK1 w - - 4 21",
        "Moves": "d6e5 a8g2",
        "Rating": 755,
        "RatingDeviation": 82,
        "Popularity": 100,
        "NbPlays": 66,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/Iva57KFW#40",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HoG",
        "FEN": "5r1k/5r2/2b2RQp/1p1p2p1/1q4P1/8/8/1B3R1K b - - 0 36",
        "Moves": "f7f6 g6h7",
        "Rating": 1489,
        "RatingDeviation": 78,
        "Popularity": 94,
        "NbPlays": 3038,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/zwJu9mKP/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Hxb",
        "FEN": "1rbr1k2/p4ppp/2B5/2pR1NP1/2P5/P7/7P/4R1K1 b - - 0 27",
        "Moves": "d8d5 e1e8",
        "Rating": 1126,
        "RatingDeviation": 80,
        "Popularity": 83,
        "NbPlays": 1101,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/FW9LwaHK/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00IPp",
        "FEN": "4Q3/6pk/p3p2p/5p2/1p1P2P1/4q2P/2B1n2B/7K w - - 0 35",
        "Moves": "g4f5 e3f3",
        "Rating": 1597,
        "RatingDeviation": 88,
        "Popularity": 88,
        "NbPlays": 1904,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/JKNcTJw1#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ITc",
        "FEN": "3r1rk1/3b1pp1/7p/8/N2Qp1n1/1P6/PB1q1PP1/R5K1 b - - 1 25",
        "Moves": "d7a4 d4g7",
        "Rating": 922,
        "RatingDeviation": 80,
        "Popularity": 88,
        "NbPlays": 119,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/tGroDLV4/black#49",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00IaZ",
        "FEN": "4R3/1k2R3/3K2p1/1P6/1P6/2rp3r/8/8 b - - 3 45",
        "Moves": "b7b6 e8b8",
        "Rating": 925,
        "RatingDeviation": 83,
        "Popularity": 83,
        "NbPlays": 426,
        "Themes": "endgame master mate mateIn1 oneMove rookEndgame",
        "GameUrl": "https://lichess.org/MA0bo8dV/black#89",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00J7i",
        "FEN": "3r2k1/pQ3ppp/4R1n1/2q5/2P5/2B3P1/P4PBP/6K1 b - - 0 24",
        "Moves": "f7e6 b7g7",
        "Rating": 1002,
        "RatingDeviation": 100,
        "Popularity": 69,
        "NbPlays": 43,
        "Themes": "endgame master masterVsMaster mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/nBfwpOrE/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00JO7",
        "FEN": "5rk1/ppq3pR/4p1r1/3p4/8/2P4Q/PP3RPP/6K1 b - - 0 22",
        "Moves": "c7c5 h7h8",
        "Rating": 989,
        "RatingDeviation": 77,
        "Popularity": 89,
        "NbPlays": 74,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/Vd3DWn3Y/black#43",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00K48",
        "FEN": "6Qk/6pp/p2B4/2pP4/P1q5/6P1/2P1p2P/5RK1 b - - 0 26",
        "Moves": "h8g8 f1f8",
        "Rating": 537,
        "RatingDeviation": 83,
        "Popularity": 100,
        "NbPlays": 94,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/vGu9FCAH/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00KYE",
        "FEN": "r1b2k1r/pp4p1/2pq2p1/3p4/3p4/1N6/PPP2PPP/R2Q1RK1 w - - 0 17",
        "Moves": "d1d4 d6h2",
        "Rating": 920,
        "RatingDeviation": 102,
        "Popularity": 86,
        "NbPlays": 182,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/IOpSkMQi#32",
        "OpeningTags": "Italian_Game Italian_Game_Scotch_Gambit"
    },
    {
        "PuzzleId": "00KgR",
        "FEN": "5r1k/1pq3p1/2p2P1p/3pPQ2/1p1P4/7P/1rB4K/5R2 b - - 1 35",
        "Moves": "f8f6 f5h7",
        "Rating": 1124,
        "RatingDeviation": 197,
        "Popularity": 100,
        "NbPlays": 7,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/8f0kmTFT/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00MYL",
        "FEN": "1R6/3k1Q2/p2b1p2/2r1p3/3n4/P6P/5PP1/4qBK1 b - - 1 40",
        "Moves": "d7c6 f7b7",
        "Rating": 1025,
        "RatingDeviation": 80,
        "Popularity": 93,
        "NbPlays": 504,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/fwb6IEPk/black#79",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Mbv",
        "FEN": "2k2b1r/pp3ppp/1n6/BN2p1P1/2Q1Nn1P/8/PP3P2/2KR4 b - - 0 24",
        "Moves": "b6c4 d1d8",
        "Rating": 1341,
        "RatingDeviation": 96,
        "Popularity": 88,
        "NbPlays": 50,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/h1QfViUk/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00OPk",
        "FEN": "6rk/7p/R2N3P/1r6/1P5K/P7/8/8 b - - 4 50",
        "Moves": "b5d5 d6f7",
        "Rating": 700,
        "RatingDeviation": 103,
        "Popularity": 93,
        "NbPlays": 862,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/aDJVIeGE/black#99",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00OXc",
        "FEN": "8/5K1p/1p4pk/8/3brp2/5R2/8/8 b - - 5 50",
        "Moves": "g6g5 f3h3",
        "Rating": 572,
        "RatingDeviation": 82,
        "Popularity": 99,
        "NbPlays": 719,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/Dp1LJyaZ/black#99",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Or5",
        "FEN": "r2qkbnr/pp5p/8/4Nb2/3p4/1QN5/PP2PPPP/R3KB1R b KQkq - 1 12",
        "Moves": "d4c3 b3f7",
        "Rating": 1462,
        "RatingDeviation": 89,
        "Popularity": 56,
        "NbPlays": 235,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/29LGsamW/black#23",
        "OpeningTags": "Slav_Defense Slav_Defense_Other_variations"
    },
    {
        "PuzzleId": "00Ozz",
        "FEN": "3kRr2/3n1B1p/2pP4/p1n5/Ppp5/8/1P3PPP/4R1K1 b - - 8 32",
        "Moves": "f8e8 e1e8",
        "Rating": 868,
        "RatingDeviation": 100,
        "Popularity": 84,
        "NbPlays": 192,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/gO3w1uZJ/black#63",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00P7n",
        "FEN": "r4rk1/p1p1R1pp/2p2p2/5P2/6Q1/1P5P/q5PK/8 b - - 1 30",
        "Moves": "a2b3 g4g7",
        "Rating": 1465,
        "RatingDeviation": 456,
        "Popularity": 71,
        "NbPlays": 6,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/bFrOMLOq/black#59",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00QY3",
        "FEN": "2k3r1/pp5p/4p3/2p2p2/2P5/P4P1q/1PQ1RR1b/7K w - - 0 32",
        "Moves": "f2h2 h3f1",
        "Rating": 1055,
        "RatingDeviation": 76,
        "Popularity": 88,
        "NbPlays": 279,
        "Themes": "endgame master mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/Ip4qQXo1#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00QZV",
        "FEN": "r1bk4/pppp3p/2n5/2b1prN1/8/1B6/PPPP2PP/RNB2RK1 w - - 1 14",
        "Moves": "g1h1 f5f1",
        "Rating": 600,
        "RatingDeviation": 88,
        "Popularity": 33,
        "NbPlays": 61,
        "Themes": "backRankMate hangingPiece mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/0CTltFgg#26",
        "OpeningTags": "Italian_Game Italian_Game_Two_Knights_Defense"
    },
    {
        "PuzzleId": "00R0m",
        "FEN": "8/4k2p/Q1p1p3/p2pP1r1/q7/P6P/1P3PK1/2R2R2 w - - 1 28",
        "Moves": "g2f3 a4e4",
        "Rating": 1356,
        "RatingDeviation": 98,
        "Popularity": 38,
        "NbPlays": 25,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/qcC85YJl#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00RoG",
        "FEN": "2kr2nr/pp2nppp/2pp4/2b2PP1/4NPq1/3B1R2/PPP4P/R2QB2K w - - 5 18",
        "Moves": "h2h3 g4g1",
        "Rating": 1052,
        "RatingDeviation": 83,
        "Popularity": 93,
        "NbPlays": 612,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/rOjlXCXv#34",
        "OpeningTags": "Scotch_Game Scotch_Game_Other_variations"
    },
    {
        "PuzzleId": "00S5q",
        "FEN": "r4rk1/pbp1n1pp/1p1p4/3Pp1N1/2B4P/2PQ4/PP3qP1/R2K3R b - - 1 17",
        "Moves": "f2g2 d3h7",
        "Rating": 989,
        "RatingDeviation": 163,
        "Popularity": 90,
        "NbPlays": 16,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/CwLT7XOm/black#33",
        "OpeningTags": "Dutch_Defense Dutch_Defense_Raphael_Variation"
    },
    {
        "PuzzleId": "00SMl",
        "FEN": "r4rk1/ppp2pn1/2np4/q2N4/3PP3/5P2/PPP5/1K1R1B1R b - - 2 18",
        "Moves": "c6b4 d5f6",
        "Rating": 810,
        "RatingDeviation": 85,
        "Popularity": 97,
        "NbPlays": 855,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/vYCG7ony/black#35",
        "OpeningTags": "Kings_Gambit_Accepted Kings_Gambit_Accepted_Cunningham_Defense"
    },
    {
        "PuzzleId": "00SOy",
        "FEN": "6k1/6b1/p1r1p2p/1pN4r/3P3q/2P2Q2/P4PP1/1R2R1K1 w - - 2 31",
        "Moves": "f3c6 h4h1",
        "Rating": 542,
        "RatingDeviation": 82,
        "Popularity": 97,
        "NbPlays": 502,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/nkJegacG#60",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00STy",
        "FEN": "8/1R5R/4kpp1/4p3/4P2K/5P1P/r7/6r1 b - - 10 40",
        "Moves": "a2h2 b7b6",
        "Rating": 1582,
        "RatingDeviation": 81,
        "Popularity": 81,
        "NbPlays": 572,
        "Themes": "endgame mate mateIn1 oneMove rookEndgame",
        "GameUrl": "https://lichess.org/yc8Ey5PU/black#79",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00SeK",
        "FEN": "7k/pp5p/4r1pP/5pP1/3Q1n2/P1P5/KP6/5q2 b - - 1 35",
        "Moves": "h8g8 d4g7",
        "Rating": 1005,
        "RatingDeviation": 182,
        "Popularity": 89,
        "NbPlays": 25,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/GRpzFRNZ/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00SfT",
        "FEN": "r4rk1/pb2ppb1/1q6/6PQ/8/2NP1N2/PPnK1PP1/R6R b - - 1 16",
        "Moves": "c2a1 h5h7",
        "Rating": 1133,
        "RatingDeviation": 80,
        "Popularity": 93,
        "NbPlays": 881,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/5y0Ha2gI/black#31",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Modern_Variation"
    },
    {
        "PuzzleId": "00T85",
        "FEN": "8/8/8/8/8/4K3/1k3Q2/1q6 b - - 5 53",
        "Moves": "b2c1 f2d2",
        "Rating": 922,
        "RatingDeviation": 76,
        "Popularity": 97,
        "NbPlays": 1120,
        "Themes": "endgame master mate mateIn1 oneMove queenEndgame",
        "GameUrl": "https://lichess.org/j3dOR5SJ/black#105",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00UkB",
        "FEN": "8/8/n1R4p/P5p1/r4p1k/7P/5PK1/8 b - - 5 50",
        "Moves": "a4a5 c6h6",
        "Rating": 962,
        "RatingDeviation": 157,
        "Popularity": 100,
        "NbPlays": 13,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/A2DzkmFy/black#99",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00VIe",
        "FEN": "8/8/8/P6p/8/2RnkN2/r7/3K4 w - - 1 60",
        "Moves": "f3e1 a2d2",
        "Rating": 1624,
        "RatingDeviation": 84,
        "Popularity": 94,
        "NbPlays": 15145,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/ugqyRWZm#118",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ViT",
        "FEN": "6k1/5pp1/4p2p/1p1bPP2/1P1P1KP1/1r6/3B1R1P/8 w - - 0 37",
        "Moves": "f5f6 g7g5",
        "Rating": 1405,
        "RatingDeviation": 111,
        "Popularity": 69,
        "NbPlays": 64,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/GZhSC72T#72",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00X1l",
        "FEN": "5r1k/Q6p/1pb3p1/4q3/4p3/1BP2p1P/PP4P1/5RK1 b - - 0 30",
        "Moves": "f3g2 f1f8",
        "Rating": 852,
        "RatingDeviation": 100,
        "Popularity": 83,
        "NbPlays": 368,
        "Themes": "endgame hangingPiece mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/IPGWdtue/black#59",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00X2S",
        "FEN": "2kr4/1p4pp/p1p1b3/Q3Bq2/8/4PB2/1PP2PPP/1K6 b - - 2 24",
        "Moves": "g7g5 a5c7",
        "Rating": 1134,
        "RatingDeviation": 244,
        "Popularity": 30,
        "NbPlays": 16,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/4JI17kTq/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00XNY",
        "FEN": "2r5/p4p1k/1p1pq3/2p2p2/7R/2Q4P/1P3PP1/6K1 b - - 1 34",
        "Moves": "h7g8 c3h8",
        "Rating": 501,
        "RatingDeviation": 94,
        "Popularity": 79,
        "NbPlays": 105,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/eG661aPJ/black#67",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Xfn",
        "FEN": "rn4k1/pp1q1r2/2pp2B1/3P4/2PB2b1/8/P2K1PP1/7R b - - 1 21",
        "Moves": "c6d5 h1h8",
        "Rating": 1416,
        "RatingDeviation": 89,
        "Popularity": 75,
        "NbPlays": 320,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/UcRGVasb/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Xiu",
        "FEN": "8/pp3Q1p/1n2B1pk/8/6Pq/7P/PPP2P2/2K5 w - - 10 31",
        "Moves": "f2f4 h4e1",
        "Rating": 608,
        "RatingDeviation": 84,
        "Popularity": 79,
        "NbPlays": 145,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/cVckB6RZ#60",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00YqR",
        "FEN": "5k2/p1p4p/1pPpBp2/2qP3b/8/2PQ4/P6P/7K w - - 0 33",
        "Moves": "d3h7 h5f3",
        "Rating": 894,
        "RatingDeviation": 79,
        "Popularity": 100,
        "NbPlays": 92,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/5b6k1W51#64",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Zh6",
        "FEN": "r1bqkn1r/ppb1n1pp/2p1pB2/4N3/3PN3/3B4/PPPQ1PPP/R3K2R b KQkq - 0 12",
        "Moves": "g7f6 e4f6",
        "Rating": 921,
        "RatingDeviation": 77,
        "Popularity": 89,
        "NbPlays": 127,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/SWXElkIy/black#23",
        "OpeningTags": "French_Defense French_Defense_Normal_Variation"
    },
    {
        "PuzzleId": "00Zx9",
        "FEN": "r1b1k1nr/ppp2ppp/3p2q1/4R1B1/2B2P2/7P/P5P1/1N1Q2K1 b kq - 0 14",
        "Moves": "d6e5 d1d8",
        "Rating": 859,
        "RatingDeviation": 77,
        "Popularity": 98,
        "NbPlays": 327,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/s1lQFfLx/black#27",
        "OpeningTags": "Scotch_Game Scotch_Game_Haxo_Gambit"
    },
    {
        "PuzzleId": "00all",
        "FEN": "6k1/5ppp/4p1b1/1N1pP3/1P1n4/r7/5PPP/2R2BK1 b - - 0 25",
        "Moves": "d4b5 c1c8",
        "Rating": 505,
        "RatingDeviation": 104,
        "Popularity": 89,
        "NbPlays": 83,
        "Themes": "backRankMate endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/84IXBueE/black#49",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00b58",
        "FEN": "4k2r/1bq2pb1/4p3/1p4p1/2pn4/R4N2/1P2BPPP/3Q1RK1 w k - 2 17",
        "Moves": "f3d4 c7h2",
        "Rating": 1054,
        "RatingDeviation": 80,
        "Popularity": 93,
        "NbPlays": 85,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/DvqCBvCz#32",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Three_Knights"
    },
    {
        "PuzzleId": "00bSy",
        "FEN": "1kr1r3/1pp4p/p2b2p1/3N1p2/P7/3P1Q1P/2R2PP1/2R1q1K1 w - - 7 27",
        "Moves": "c1e1 e8e1",
        "Rating": 611,
        "RatingDeviation": 82,
        "Popularity": 100,
        "NbPlays": 133,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/s7Pa0Pux#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00bZ2",
        "FEN": "4b1k1/1r2P2p/p1p3pP/6q1/3Q4/PB6/1PP3P1/1K6 b - - 0 36",
        "Moves": "b7b3 d4g7",
        "Rating": 1056,
        "RatingDeviation": 77,
        "Popularity": 92,
        "NbPlays": 143,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/PL5NKKII/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00bzC",
        "FEN": "r1r3k1/2p3p1/p2p3p/Pp1Pp3/4P3/3P1p1q/R1Q2P1N/4R1K1 w - - 0 28",
        "Moves": "g1h1 h3g2",
        "Rating": 850,
        "RatingDeviation": 77,
        "Popularity": 82,
        "NbPlays": 64,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/VwQi9pgI#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00c0D",
        "FEN": "rnb1k2r/ppB2p2/8/3p2p1/3Q2np/2N2NK1/PPP1B1PP/R6R w kq - 0 14",
        "Moves": "g3h3 g4f2",
        "Rating": 817,
        "RatingDeviation": 91,
        "Popularity": 76,
        "NbPlays": 68,
        "Themes": "doubleCheck mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/JCwpco4I#26",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Zukertort_Variation"
    },
    {
        "PuzzleId": "00c89",
        "FEN": "2r2rk1/6pp/p1q5/1pn2p2/1B1pPP2/3Pn1QB/1PP2R1P/6RK b - - 3 24",
        "Moves": "f8f6 g3g7",
        "Rating": 400,
        "RatingDeviation": 97,
        "Popularity": 55,
        "NbPlays": 315,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/qy4azPDa/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00cZ4",
        "FEN": "8/2R5/6pk/p3p2p/4Nq2/5n1P/P2R2P1/7K w - - 0 41",
        "Moves": "d2f2 f4h2",
        "Rating": 1059,
        "RatingDeviation": 79,
        "Popularity": 87,
        "NbPlays": 202,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/uEKnkWhW#80",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00d8a",
        "FEN": "r1b1k2r/1p3p2/p1pqp3/2b2Ppp/4P1n1/2NB3P/PPP3P1/R2QBR1K w kq - 1 15",
        "Moves": "d1f3 d6h2",
        "Rating": 1086,
        "RatingDeviation": 79,
        "Popularity": 90,
        "NbPlays": 388,
        "Themes": "master mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/nWjnzIeC#28",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Kan_Variation"
    },
    {
        "PuzzleId": "00dOP",
        "FEN": "r2q1k1r/pbp1bppp/1p2pn2/1B2N3/3P1Q2/8/PPP2PPP/R1B2RK1 b - - 5 12",
        "Moves": "f6d5 f4f7",
        "Rating": 475,
        "RatingDeviation": 84,
        "Popularity": 100,
        "NbPlays": 376,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/RvqmzkCr/black#23",
        "OpeningTags": "French_Defense French_Defense_Tarrasch_Variation"
    },
    {
        "PuzzleId": "00dzs",
        "FEN": "3k1b1r/1p1n1ppp/1B6/1p6/8/5K2/PPr2PPP/3RR3 b - - 1 19",
        "Moves": "d8c8 e1e8",
        "Rating": 789,
        "RatingDeviation": 102,
        "Popularity": 91,
        "NbPlays": 252,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/zvBG4Lv4/black#37",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00eC6",
        "FEN": "2kr4/1p3p2/1P6/Q1ppP3/3NnPqp/8/P5KP/2R1R3 w - - 1 29",
        "Moves": "g2h1 e4f2",
        "Rating": 988,
        "RatingDeviation": 128,
        "Popularity": 83,
        "NbPlays": 20,
        "Themes": "master mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/Z0Kq2Ar8#56",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00eNa",
        "FEN": "rnb1k2r/p1p2ppp/1p3n2/2b1N1B1/3qP3/3P4/PPP3PP/RN1QKB1R w KQkq - 1 8",
        "Moves": "e5f3 d4f2",
        "Rating": 1144,
        "RatingDeviation": 76,
        "Popularity": 100,
        "NbPlays": 215,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/P6b1EEqI#14",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Leonardis_Variation"
    },
    {
        "PuzzleId": "00ems",
        "FEN": "2r1r1k1/1bpn1ppp/p4n2/1p6/1P4q1/P3PN2/1BB1QPPP/3R1RK1 w - - 6 18",
        "Moves": "f3d4 g4g2",
        "Rating": 1039,
        "RatingDeviation": 75,
        "Popularity": 100,
        "NbPlays": 591,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/mQNb8OeH#34",
        "OpeningTags": "Horwitz_Defense Horwitz_Defense_Other_variations"
    },
    {
        "PuzzleId": "00euQ",
        "FEN": "r1b1k1nr/pppp1ppp/5q2/2b1n3/4P3/2N2N2/PPPP2PP/R1BQKB1R w KQkq - 0 6",
        "Moves": "f3e5 f6f2",
        "Rating": 1099,
        "RatingDeviation": 80,
        "Popularity": 77,
        "NbPlays": 803,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/srPCKrEj#10",
        "OpeningTags": "Vienna_Gambit_with_Max_Lange_Defense Vienna_Gambit_with_Max_Lange_Defense_Other_variations"
    },
    {
        "PuzzleId": "00f1D",
        "FEN": "r1bq2kr/1p2b1pp/p2pN3/4p3/2B1P3/5Q2/PP3PPP/2RR2K1 b - - 0 17",
        "Moves": "c8e6 c4e6",
        "Rating": 813,
        "RatingDeviation": 93,
        "Popularity": 91,
        "NbPlays": 214,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/cl0wv5xF/black#33",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Smith-Morra_Gambit"
    },
    {
        "PuzzleId": "00fDM",
        "FEN": "3rrbk1/2p3R1/1p2q2Q/3p4/1P6/2B4P/6P1/3R2K1 b - - 0 33",
        "Moves": "f8g7 h6g7",
        "Rating": 875,
        "RatingDeviation": 78,
        "Popularity": 97,
        "NbPlays": 322,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/sx01PyS8/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00fK0",
        "FEN": "r2q1r2/pp3pk1/2np1Np1/2pN1b2/2B4Q/3P4/PPP3PP/R5K1 b - - 1 17",
        "Moves": "f5e6 h4h7",
        "Rating": 823,
        "RatingDeviation": 103,
        "Popularity": 95,
        "NbPlays": 241,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/PSCBXZwl/black#33",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Closed"
    },
    {
        "PuzzleId": "00fXd",
        "FEN": "8/Q5b1/p2kp3/1p2qpN1/1P6/P7/4nPP1/5K2 b - - 5 46",
        "Moves": "d6d5 a7c5",
        "Rating": 1477,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 1507,
        "Themes": "endgame master mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/PkmRzeiI/black#91",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00fZM",
        "FEN": "5rk1/1q3r1p/3p2RQ/3p4/3B4/2P2P2/P5PP/6K1 b - - 0 30",
        "Moves": "h7g6 h6h8",
        "Rating": 861,
        "RatingDeviation": 78,
        "Popularity": 96,
        "NbPlays": 2433,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/F6b275RM/black#59",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00g2W",
        "FEN": "6k1/1q4p1/p2P2B1/8/5Q1P/6P1/P6K/4r3 w - - 5 36",
        "Moves": "f4f2 b7h1",
        "Rating": 726,
        "RatingDeviation": 94,
        "Popularity": 47,
        "NbPlays": 38,
        "Themes": "endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/QG0oodxm#70",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00g5t",
        "FEN": "5rk1/p1p3p1/bp2p2p/5p2/2qPB3/2P5/2Q2PPP/R4RK1 w - - 0 24",
        "Moves": "a1a4 c4f1",
        "Rating": 1246,
        "RatingDeviation": 104,
        "Popularity": 76,
        "NbPlays": 46,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/aVCFv31r#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ggZ",
        "FEN": "2r2r1k/1pP3pp/p3b3/P7/1P5Q/4q1P1/6PK/RB6 b - - 4 37",
        "Moves": "c8c7 h4h7",
        "Rating": 753,
        "RatingDeviation": 84,
        "Popularity": 86,
        "NbPlays": 85,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/gCG08rHD/black#73",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00j1r",
        "FEN": "8/2rkb3/1p6/6P1/5q2/3R4/Q1P1K3/8 b - - 4 37",
        "Moves": "d7c6 a2d5",
        "Rating": 1641,
        "RatingDeviation": 76,
        "Popularity": 92,
        "NbPlays": 2642,
        "Themes": "dovetailMate endgame mate mateIn1 oneMove",
        "GameUrl": "https://lichess.org/2Nj3D5mV/black#73",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00jPw",
        "FEN": "r3r1k1/ppp2p2/1b5Q/3PP2n/2B3bq/2N5/PP4PP/R4R1K w - - 1 18",
        "Moves": "f1f7 h5g3",
        "Rating": 1136,
        "RatingDeviation": 75,
        "Popularity": 96,
        "NbPlays": 1718,
        "Themes": "mate mateIn1 middlegame oneMove pin",
        "GameUrl": "https://lichess.org/rMGqxihy#34",
        "OpeningTags": "Italian_Game Italian_Game_Classical_Variation"
    },
    {
        "PuzzleId": "00k4u",
        "FEN": "r2b2r1/p2P1p2/1pNQ1p1k/6qp/5R2/P2B3P/1P3PP1/6K1 w - - 2 28",
        "Moves": "c6d8 g5g2",
        "Rating": 863,
        "RatingDeviation": 130,
        "Popularity": 81,
        "NbPlays": 48,
        "Themes": "kingsideAttack master mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/wDp8QswW#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00kT1",
        "FEN": "r2q1rk1/pb2bpp1/2p1p3/4P3/2nP3p/P1PQBN1P/2B2PP1/R4RK1 b - - 5 18",
        "Moves": "c4e3 d3h7",
        "Rating": 959,
        "RatingDeviation": 77,
        "Popularity": 64,
        "NbPlays": 99,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/KBx6qbtc/black#35",
        "OpeningTags": "Queens_Gambit_Accepted Queens_Gambit_Accepted_Other_variations"
    },
    {
        "PuzzleId": "00mJq",
        "FEN": "r1b5/pp1nkpr1/2q1p3/8/8/3B4/P1P1NPPP/R2Q1RK1 w - - 3 18",
        "Moves": "e2d4 c6g2",
        "Rating": 669,
        "RatingDeviation": 96,
        "Popularity": 96,
        "NbPlays": 269,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/qGtdon3N#34",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Mieses-Kotroc_Variation"
    },
    {
        "PuzzleId": "00n6z",
        "FEN": "r2Rrk1q/p3Np2/1pp5/8/P1Q1P1pP/2P2P2/1P3bP1/3R3K w - - 5 34",
        "Moves": "d8a8 h8h4",
        "Rating": 1195,
        "RatingDeviation": 77,
        "Popularity": 83,
        "NbPlays": 196,
        "Themes": "kingsideAttack mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/WrP84lz1#66",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00nNa",
        "FEN": "8/2k3pp/4p3/1R3p2/1Pr2K1P/6P1/5P2/8 w - - 7 37",
        "Moves": "f4e5 c4e4",
        "Rating": 1270,
        "RatingDeviation": 97,
        "Popularity": 71,
        "NbPlays": 107,
        "Themes": "endgame mate mateIn1 oneMove rookEndgame",
        "GameUrl": "https://lichess.org/WsRWmvEZ#72",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ndv",
        "FEN": "r1bq1rBk/pp2npp1/4p3/3p4/3P2n1/2P2NP1/PPQN1PP1/R3K2R b KQ - 2 13",
        "Moves": "h8g8 c2h7",
        "Rating": 798,
        "RatingDeviation": 96,
        "Popularity": 85,
        "NbPlays": 34,
        "Themes": "mate mateIn1 middlegame oneMove",
        "GameUrl": "https://lichess.org/CAhN6VbK/black#25",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_London_System"
    },
    {
        "PuzzleId": "000Zo",
        "FEN": "4r3/1k6/pp3r2/1b2P2p/3R1p2/P1R2P2/1P4PP/6K1 w - - 0 35",
        "Moves": "e5f6 e8e1 g1f2 e1f1",
        "Rating": 1311,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 569,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/n8Ff742v#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "000hf",
        "FEN": "r1bqk2r/pp1nbNp1/2p1p2p/8/2BP4/1PN3P1/P3QP1P/3R1RK1 b kq - 0 19",
        "Moves": "e8f7 e2e6 f7f8 e6f7",
        "Rating": 1590,
        "RatingDeviation": 75,
        "Popularity": 89,
        "NbPlays": 473,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/71ygsFeE/black#37",
        "OpeningTags": "Horwitz_Defense Horwitz_Defense_Other_variations"
    },
    {
        "PuzzleId": "001Wz",
        "FEN": "4r1k1/5ppp/r1p5/p1n1RP2/8/2P2N1P/2P3P1/3R2K1 b - - 0 21",
        "Moves": "e8e5 d1d8 e5e8 d8e8",
        "Rating": 1127,
        "RatingDeviation": 82,
        "Popularity": 87,
        "NbPlays": 69,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/84RH3LaP/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001om",
        "FEN": "5r1k/pp4pp/5p2/1BbQp1r1/6K1/7P/1PP3P1/3R3R w - - 2 26",
        "Moves": "g4h4 c5f2 g2g3 f2g3",
        "Rating": 1018,
        "RatingDeviation": 80,
        "Popularity": 89,
        "NbPlays": 219,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/VWOIWtIh#50",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001w5",
        "FEN": "1rb2rk1/q5P1/4p2p/3p3p/3P1P2/2P5/2QK3P/3R2R1 b - - 0 29",
        "Moves": "f8f7 c2h7 g8h7 g7g8q",
        "Rating": 1127,
        "RatingDeviation": 81,
        "Popularity": 92,
        "NbPlays": 195,
        "Themes": "advancedPawn attraction mate mateIn2 middlegame promotion short",
        "GameUrl": "https://lichess.org/0e1vxAEn/black#57",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003Tx",
        "FEN": "2r5/pR5p/5p1k/4p3/4r3/B4nPP/PP3P2/1K2R3 w - - 0 27",
        "Moves": "e1e4 f3d2 b1a1 c8c1",
        "Rating": 1529,
        "RatingDeviation": 89,
        "Popularity": 83,
        "NbPlays": 680,
        "Themes": "backRankMate endgame fork mate mateIn2 short",
        "GameUrl": "https://lichess.org/A7j9VEC0#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0042j",
        "FEN": "3r2k1/4nppp/pq1p1b2/1p2P3/2r2P2/2P1NR2/PP1Q2BP/3R2K1 b - - 0 24",
        "Moves": "d6e5 d2d8 b6d8 d1d8",
        "Rating": 427,
        "RatingDeviation": 103,
        "Popularity": 94,
        "NbPlays": 1179,
        "Themes": "backRankMate mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/DuM2FZjg/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004X6",
        "FEN": "1r4k1/p4ppp/2Q5/3pq3/8/P6P/2PR1PP1/Rr4K1 w - - 1 26",
        "Moves": "a1b1 b8b1 d2d1 b1d1",
        "Rating": 1176,
        "RatingDeviation": 278,
        "Popularity": 83,
        "NbPlays": 11,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/wvPFkjF9#50",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005N7",
        "FEN": "r6k/2q3pp/8/2p1n3/R1Qp4/7P/2PB1PP1/6K1 b - - 0 32",
        "Moves": "e5c4 a4a8 c7b8 a8b8",
        "Rating": 448,
        "RatingDeviation": 102,
        "Popularity": 93,
        "NbPlays": 1560,
        "Themes": "backRankMate endgame hangingPiece mate mateIn2 short",
        "GameUrl": "https://lichess.org/jxZhmGhg/black#63",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005nD",
        "FEN": "3rk2r/2qn1pp1/p1Q1R3/3n3p/8/8/PP4PP/5R1K b k - 0 23",
        "Moves": "f7e6 c6e6 d5e7 e6f7",
        "Rating": 964,
        "RatingDeviation": 79,
        "Popularity": 100,
        "NbPlays": 216,
        "Themes": "fork mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/hlgaj6lV/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0061g",
        "FEN": "6k1/pp3pp1/2p1q1Pp/3b4/8/6Q1/PB3Pp1/3RrNK1 b - - 2 27",
        "Moves": "e1d1 g3b8 e6e8 b8e8",
        "Rating": 803,
        "RatingDeviation": 91,
        "Popularity": 72,
        "NbPlays": 264,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/dJ3xEKJK/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "006HV",
        "FEN": "1r6/5k2/2p1pNp1/p5Pp/1pQ1P2P/2P4R/KP3P2/3q4 w - - 4 31",
        "Moves": "c4c6 b4b3 a2a3 d1a1",
        "Rating": 1293,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 950,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/ibb2c72C#60",
        "OpeningTags": null
    },
    {
        "PuzzleId": "007Rn",
        "FEN": "4r1k1/p4p1p/1p6/6q1/3P2n1/P4Q2/1P1B2P1/7K w - - 0 34",
        "Moves": "d2g5 e8e1 f3f1 e1f1",
        "Rating": 992,
        "RatingDeviation": 82,
        "Popularity": 75,
        "NbPlays": 74,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/L9kH7FqT#66",
        "OpeningTags": null
    },
    {
        "PuzzleId": "007XE",
        "FEN": "2kr3r/p1p1bpp1/2p2n1p/8/8/1P6/P1P1RPPP/RNB3K1 w - - 1 16",
        "Moves": "e2e7 d8d1 e7e1 d1e1",
        "Rating": 663,
        "RatingDeviation": 92,
        "Popularity": 79,
        "NbPlays": 62,
        "Themes": "backRankMate fork mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/f4f7UwiT#30",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Leonardis_Variation"
    },
    {
        "PuzzleId": "007ku",
        "FEN": "r1bq3Q/1np2kp1/p5B1/1p1Pp3/1Pn2BP1/2b2P2/P3K3/R4N2 b - - 5 35",
        "Moves": "f7g6 h8h5 g6f6 f4g5",
        "Rating": 1605,
        "RatingDeviation": 74,
        "Popularity": 88,
        "NbPlays": 957,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/QveLbBjG/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008GK",
        "FEN": "1k1r4/ppp3p1/8/1P5p/8/P3n2P/2P1r1P1/B3NRK1 b - - 4 31",
        "Moves": "d8d1 f1f8 d1d8 f8d8",
        "Rating": 439,
        "RatingDeviation": 98,
        "Popularity": 89,
        "NbPlays": 1604,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/9vFFDYsH/black#61",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008oX",
        "FEN": "4r1k1/2R3pp/2p4q/1p1p4/3P4/P7/1PP2R2/1K1N4 b - - 3 32",
        "Moves": "e8e1 c7c8 e1e8 c8e8",
        "Rating": 978,
        "RatingDeviation": 76,
        "Popularity": 71,
        "NbPlays": 217,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/APGKH8YH/black#63",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0092z",
        "FEN": "2r3k1/2qR1ppp/p7/2p2Q2/P7/7P/5PP1/6K1 b - - 3 26",
        "Moves": "c7c6 f5f7 g8h8 f7g7",
        "Rating": 949,
        "RatingDeviation": 84,
        "Popularity": 94,
        "NbPlays": 411,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/fjaha7q0/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009IO",
        "FEN": "3rk3/5p1r/p2Np1p1/3bP3/P2n4/8/1P3RPP/5RK1 b - - 4 25",
        "Moves": "e8e7 f2f7 h7f7 f1f7",
        "Rating": 1168,
        "RatingDeviation": 81,
        "Popularity": 87,
        "NbPlays": 539,
        "Themes": "hookMate mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/LJBrm9Or/black#49",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009bR",
        "FEN": "4r2k/3q2r1/1p4pQ/p1pP4/2P4P/1N4p1/PP3RK1/8 b - - 1 37",
        "Moves": "g7h7 f2f8 e8f8 h6f8",
        "Rating": 1069,
        "RatingDeviation": 319,
        "Popularity": 100,
        "NbPlays": 1,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/rvHGlZar/black#73",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009f8",
        "FEN": "8/1p4p1/pb2ppkp/3n4/3P4/P3BN1P/1P2KPP1/8 b - - 0 26",
        "Moves": "g6f5 f3h4 f5e4 f2f3",
        "Rating": 1171,
        "RatingDeviation": 76,
        "Popularity": 89,
        "NbPlays": 120,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/paDYagZM/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009lk",
        "FEN": "1R6/6pk/2p4p/3bP2r/5B1P/2P2qP1/P4P1Q/4R1K1 w - - 2 40",
        "Moves": "e1e3 f3d1 e3e1 d1e1",
        "Rating": 925,
        "RatingDeviation": 79,
        "Popularity": 95,
        "NbPlays": 876,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/gLNPef4f#78",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009oc",
        "FEN": "5Q2/pbp3np/1p1pB1pk/1P6/P3q2P/6K1/8/8 b - - 1 32",
        "Moves": "e4e6 f8f4 g6g5 f4g5",
        "Rating": 961,
        "RatingDeviation": 88,
        "Popularity": 95,
        "NbPlays": 512,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/426eHXom/black#63",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009uB",
        "FEN": "3br2r/5k1p/4p1pQ/P5P1/1B5P/P6q/5R2/6K1 b - - 1 35",
        "Moves": "f7g8 f2f8 e8f8 h6f8",
        "Rating": 1097,
        "RatingDeviation": 75,
        "Popularity": 100,
        "NbPlays": 176,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/1llcQdqK/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009zR",
        "FEN": "3r4/p1p2ppp/4k3/6Q1/5P2/4P3/Prqn2PP/3R1RK1 w - - 3 22",
        "Moves": "g5d8 d2f3 g1h1 c2g2",
        "Rating": 1616,
        "RatingDeviation": 78,
        "Popularity": 87,
        "NbPlays": 168,
        "Themes": "discoveredAttack endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/SctCD3fJ#42",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Bg4",
        "FEN": "3r2k1/1q3ppp/p2rp3/Qp1B4/7P/P4P2/1PP3P1/1K1R3R b - - 0 21",
        "Moves": "d6d5 a5d8 d5d8 d1d8",
        "Rating": 1370,
        "RatingDeviation": 85,
        "Popularity": 75,
        "NbPlays": 306,
        "Themes": "backRankMate endgame mate mateIn2 short xRayAttack",
        "GameUrl": "https://lichess.org/6qWf8wOP/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00CBU",
        "FEN": "8/2pR2kp/pb4p1/8/5p1P/B6K/P1r5/6r1 b - - 3 39",
        "Moves": "g7h6 a3f8 h6h5 d7h7",
        "Rating": 1826,
        "RatingDeviation": 81,
        "Popularity": 76,
        "NbPlays": 42,
        "Themes": "deflection endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/8sbUxgqT/black#77",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00CpR",
        "FEN": "4r1k1/B7/2p2pK1/3n3p/8/1Q3PP1/P6r/8 b - - 0 31",
        "Moves": "e8e5 b3b8 e5e8 b8e8",
        "Rating": 601,
        "RatingDeviation": 82,
        "Popularity": 84,
        "NbPlays": 298,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/tX2xyrPX/black#61",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00CtS",
        "FEN": "Q5k1/5q2/p2p4/b1p1pr2/P7/6P1/4KP1R/8 b - - 3 38",
        "Moves": "g8g7 a8h8 g7g6 h8h6",
        "Rating": 960,
        "RatingDeviation": 79,
        "Popularity": 97,
        "NbPlays": 2822,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/yKolw9vl/black#75",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Cwz",
        "FEN": "1r5r/5pk1/4p3/2Np2PP/p1nP4/n1P5/P3B3/K1R4R w - - 2 34",
        "Moves": "c5a4 b8b1 c1b1 a3c2",
        "Rating": 1506,
        "RatingDeviation": 79,
        "Popularity": 87,
        "NbPlays": 99,
        "Themes": "mate mateIn2 middlegame sacrifice short",
        "GameUrl": "https://lichess.org/o6LOeNAf#66",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00EEp",
        "FEN": "3k2q1/pb1p3p/1p1P4/2p5/2P2Q1K/8/P7/5R2 b - - 2 36",
        "Moves": "b7g2 f4f8 g8f8 f1f8",
        "Rating": 1607,
        "RatingDeviation": 83,
        "Popularity": 86,
        "NbPlays": 55,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/dWHeDlRz/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00F2o",
        "FEN": "6k1/4qpp1/3p3p/8/2BP4/1Pn5/2Qn1PPP/6K1 w - - 0 29",
        "Moves": "c2c3 e7e1 c4f1 e1f1",
        "Rating": 980,
        "RatingDeviation": 76,
        "Popularity": 72,
        "NbPlays": 120,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/Xik1cEk4#56",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00H8a",
        "FEN": "5bk1/2R4p/6p1/8/2b1NP1P/4P1K1/r7/8 b - - 2 45",
        "Moves": "c4d3 e4f6 g8h8 c7h7",
        "Rating": 762,
        "RatingDeviation": 108,
        "Popularity": 100,
        "NbPlays": 36,
        "Themes": "arabianMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/7UUQgJDC/black#89",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HEh",
        "FEN": "3R1rk1/pp3ppp/2p3b1/2n3P1/2B2q1P/5N2/PPP1QP2/4R1K1 b - - 0 23",
        "Moves": "f8d8 e2e8 d8e8 e1e8",
        "Rating": 814,
        "RatingDeviation": 86,
        "Popularity": 90,
        "NbPlays": 436,
        "Themes": "kingsideAttack mate mateIn2 middlegame sacrifice short",
        "GameUrl": "https://lichess.org/ekEf00kl/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HZC",
        "FEN": "4r1k1/pp1qn3/2p4R/6p1/3P1rR1/3Q2P1/PP3P1P/6K1 b - - 0 31",
        "Moves": "f4g4 d3h7 g8f8 h6f6",
        "Rating": 1541,
        "RatingDeviation": 76,
        "Popularity": 61,
        "NbPlays": 129,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/SPwu7cIA/black#61",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HzH",
        "FEN": "2r2Qk1/p2q2p1/1p2p1Np/3p3P/3Pb1P1/2P5/PP3R2/6K1 b - - 4 33",
        "Moves": "c8f8 f2f8 g8h7 f8h8",
        "Rating": 800,
        "RatingDeviation": 83,
        "Popularity": 90,
        "NbPlays": 354,
        "Themes": "endgame hookMate mate mateIn2 short",
        "GameUrl": "https://lichess.org/XB8lgZ9N/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00J1Y",
        "FEN": "1q3r2/p5k1/1p2pbpp/2p2p2/2P1N3/2P2PQP/PP3P2/6RK b - - 2 29",
        "Moves": "f5e4 g3g6 g7h8 g6h6",
        "Rating": 1263,
        "RatingDeviation": 74,
        "Popularity": 100,
        "NbPlays": 379,
        "Themes": "deflection endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/8onUzszE/black#57",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00JQS",
        "FEN": "5r1k/pb3Qpp/2p5/5p2/3P4/8/PPP2PPP/4R1K1 b - - 0 21",
        "Moves": "f8f7 e1e8 f7f8 e8f8",
        "Rating": 583,
        "RatingDeviation": 93,
        "Popularity": 76,
        "NbPlays": 624,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/jB9KjawU/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00JS1",
        "FEN": "2r5/1p2k1pp/4p3/1N3p2/5P2/P2nP3/1R4PP/6K1 w - - 0 24",
        "Moves": "b2d2 c8c1 d2d1 c1d1",
        "Rating": 583,
        "RatingDeviation": 102,
        "Popularity": 77,
        "NbPlays": 678,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/ROJJOhHY#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00KVb",
        "FEN": "2k2r2/pp5p/3p4/3Nb1p1/8/1P1P3P/P1Pn4/1K1R1R2 w - - 3 28",
        "Moves": "d1d2 f8f1 d2d1 f1d1",
        "Rating": 579,
        "RatingDeviation": 96,
        "Popularity": 71,
        "NbPlays": 150,
        "Themes": "endgame hangingPiece mate mateIn2 short",
        "GameUrl": "https://lichess.org/tzIW1ZLM#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Keu",
        "FEN": "R7/1p3kp1/2pK3p/3p1PP1/1r1B2nP/8/1P6/8 b - - 2 39",
        "Moves": "b4d4 g5g6 f7f6 a8f8",
        "Rating": 904,
        "RatingDeviation": 83,
        "Popularity": 94,
        "NbPlays": 1365,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/hCWa2OUn/black#77",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00KhM",
        "FEN": "5rk1/5ppp/1R6/3Qp3/2B1P3/2q3P1/3R1PKP/1r6 b - - 0 27",
        "Moves": "b1b6 d5f7 f8f7 d2d8",
        "Rating": 1360,
        "RatingDeviation": 95,
        "Popularity": 78,
        "NbPlays": 36,
        "Themes": "clearance endgame mate mateIn2 pin sacrifice short",
        "GameUrl": "https://lichess.org/o5Jg9MLX/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LNB",
        "FEN": "kr6/1pR4p/p4R2/n2r4/P3p3/4B3/6PP/6K1 b - - 0 38",
        "Moves": "d5d3 f6a6 b7a6 c7a7",
        "Rating": 1057,
        "RatingDeviation": 77,
        "Popularity": 97,
        "NbPlays": 1960,
        "Themes": "endgame mate mateIn2 sacrifice short",
        "GameUrl": "https://lichess.org/MQYDGoEM/black#75",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LdT",
        "FEN": "r5k1/pbp2ppp/6q1/2pp4/3B3r/2P1R1P1/PP2QP1P/R5K1 b - - 1 20",
        "Moves": "c5d4 e3e8 a8e8 e2e8",
        "Rating": 590,
        "RatingDeviation": 90,
        "Popularity": 80,
        "NbPlays": 152,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/MH7zaBHa/black#39",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00MFe",
        "FEN": "3r3k/p5pp/2r2q2/2p4Q/8/8/P5PP/3R1R1K b - - 5 29",
        "Moves": "d8d1 h5e8 f6f8 e8f8",
        "Rating": 1261,
        "RatingDeviation": 76,
        "Popularity": 93,
        "NbPlays": 2034,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/d1J7UJ4D/black#57",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00MGA",
        "FEN": "r3r1k1/6b1/p2Nn2p/1P1Qp3/6nq/2P5/1PB2PP1/R1B1R1K1 w - - 1 30",
        "Moves": "g2g3 h4h2 g1f1 h2f2",
        "Rating": 969,
        "RatingDeviation": 87,
        "Popularity": 92,
        "NbPlays": 867,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/dsGjft94#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00MIY",
        "FEN": "6k1/3R3p/1p5q/3P4/3QP1pN/6P1/PPr3B1/5rK1 w - - 0 25",
        "Moves": "g1f1 h6c1 d4d1 c1d1",
        "Rating": 1516,
        "RatingDeviation": 85,
        "Popularity": 80,
        "NbPlays": 43,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/SHHHsXB9#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00MS3",
        "FEN": "rn1qr1k1/1p2bppp/2p2B2/p2p4/3P4/2N2N2/PPP1QPPP/2KRR3 b - - 0 12",
        "Moves": "e7f6 e2e8 d8e8 e1e8",
        "Rating": 824,
        "RatingDeviation": 83,
        "Popularity": 83,
        "NbPlays": 122,
        "Themes": "backRankMate mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/Eia6KIcR/black#23",
        "OpeningTags": "French_Defense French_Defense_Exchange_Variation"
    },
    {
        "PuzzleId": "00NAM",
        "FEN": "r5k1/pp3ppp/8/3p4/3P4/4R2P/q1P1QPPK/8 b - - 1 21",
        "Moves": "a2c4 e3e8 a8e8 e2e8",
        "Rating": 936,
        "RatingDeviation": 93,
        "Popularity": 100,
        "NbPlays": 21,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/be70QtoL/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00NOI",
        "FEN": "3r4/2k2p1p/pp2pp2/2p5/3nN3/6P1/PPP2PRP/2K5 w - - 2 23",
        "Moves": "e4f6 d4e2 c1b1 d8d1",
        "Rating": 966,
        "RatingDeviation": 89,
        "Popularity": 60,
        "NbPlays": 33,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/Z7mmtXNG#44",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00NUS",
        "FEN": "4rk2/pbp2pp1/1p1b4/3P1q2/QPBPN3/1KP2P2/P5r1/R3R3 w - - 0 25",
        "Moves": "e4d6 f5c2 b3a3 c2b2",
        "Rating": 1348,
        "RatingDeviation": 74,
        "Popularity": 94,
        "NbPlays": 1280,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/jQaVQrR6#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00NUc",
        "FEN": "6k1/6pp/1PP5/4b3/3p4/Br5P/4prP1/R5RK w - - 1 30",
        "Moves": "c6c7 b3h3 g2h3 f2h2",
        "Rating": 1650,
        "RatingDeviation": 122,
        "Popularity": 81,
        "NbPlays": 50,
        "Themes": "endgame mate mateIn2 sacrifice short",
        "GameUrl": "https://lichess.org/8FRZVN6d#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00NaX",
        "FEN": "4r1k1/1p2r3/p1p5/3p1p2/PP1P1q1p/2Q1P1pP/5PP1/4R1K1 w - - 0 39",
        "Moves": "e3f4 e7e1 c3e1 e8e1",
        "Rating": 400,
        "RatingDeviation": 98,
        "Popularity": 100,
        "NbPlays": 102,
        "Themes": "endgame kingsideAttack mate mateIn2 queenRookEndgame short",
        "GameUrl": "https://lichess.org/rZL4HlNU#76",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00O14",
        "FEN": "6k1/3P1pp1/4p3/p7/Q3R3/3q1PP1/1P3PK1/2r5 w - - 0 37",
        "Moves": "a4d4 d3f1 g2h2 f1h1",
        "Rating": 1033,
        "RatingDeviation": 77,
        "Popularity": 72,
        "NbPlays": 192,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/IynnE0r9#72",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00OCQ",
        "FEN": "1rr3k1/5p1p/p5pQ/4p3/4q3/B3P3/PPPR1PPP/2KR4 w - - 6 27",
        "Moves": "c2c3 c8c3 b2c3 b8b1",
        "Rating": 1030,
        "RatingDeviation": 75,
        "Popularity": 98,
        "NbPlays": 389,
        "Themes": "mate mateIn2 middlegame queensideAttack sacrifice short",
        "GameUrl": "https://lichess.org/kcUnWeDs#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00OOp",
        "FEN": "5rk1/1bR3q1/pQ6/8/6r1/4R2P/P7/6K1 w - - 0 28",
        "Moves": "h3g4 g7g4 e3g3 g4g3",
        "Rating": 1053,
        "RatingDeviation": 91,
        "Popularity": 86,
        "NbPlays": 82,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/N1WcEYJH#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00P6j",
        "FEN": "r2n2k1/1bRq1rpp/1p6/3P4/p3Q3/B3P3/PP3PPP/3R2K1 b - - 0 20",
        "Moves": "d7c7 e4e8 f7f8 e8f8",
        "Rating": 1352,
        "RatingDeviation": 75,
        "Popularity": 84,
        "NbPlays": 536,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/vBpR18cI/black#39",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Pbs",
        "FEN": "3r1rk1/Q3qppp/8/1ppb4/2Pn1B1n/2N3P1/PP3P2/R2R1K2 w - - 0 21",
        "Moves": "a7e7 d5g2 f1e1 h4f3",
        "Rating": 2076,
        "RatingDeviation": 76,
        "Popularity": 83,
        "NbPlays": 163,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/fA2DSaPB#40",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00PvX",
        "FEN": "8/n7/P7/3k4/PK6/7P/5PP1/8 w - - 0 53",
        "Moves": "b4a5 d5c5 f2f3 a7c6",
        "Rating": 1648,
        "RatingDeviation": 75,
        "Popularity": 86,
        "NbPlays": 237,
        "Themes": "endgame knightEndgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/tH6dRFcZ#104",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00QZ3",
        "FEN": "r1bq3r/ppppnkpp/2n5/b5N1/4P3/B1P5/P4PPP/RN1QK2R b KQ - 1 9",
        "Moves": "f7f8 d1f3 f8e8 f3f7",
        "Rating": 1173,
        "RatingDeviation": 79,
        "Popularity": 91,
        "NbPlays": 1490,
        "Themes": "mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/PiCJ1gmH/black#17",
        "OpeningTags": "Scotch_Game Scotch_Game_Scotch_Gambit"
    },
    {
        "PuzzleId": "00RYH",
        "FEN": "1k5r/ppp1R2p/3r1p2/5Q2/3p4/2qP4/2P2PPP/2K1R3 b - - 5 26",
        "Moves": "d6a6 e7e8 h8e8 e1e8",
        "Rating": 1031,
        "RatingDeviation": 81,
        "Popularity": 89,
        "NbPlays": 113,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/qGI2u50w/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Ru6",
        "FEN": "3r1r2/p5kp/1p4pP/2p5/2PbBQ2/2q5/P1P1K3/5R2 b - - 0 34",
        "Moves": "g7h8 f4f8 d8f8 f1f8",
        "Rating": 938,
        "RatingDeviation": 82,
        "Popularity": 80,
        "NbPlays": 68,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/SA1K2pZD/black#67",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00SLR",
        "FEN": "rnbqk1nr/ppppbppp/4p3/8/5P2/5N2/PPPPP1PP/RNBQKB1R w KQkq - 2 3",
        "Moves": "g2g4 e7h4 f3h4 d8h4",
        "Rating": 758,
        "RatingDeviation": 107,
        "Popularity": 94,
        "NbPlays": 425,
        "Themes": "mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/jqepvLa0#4",
        "OpeningTags": "Bird_Opening Bird_Opening_Other_variations"
    },
    {
        "PuzzleId": "00Sz9",
        "FEN": "1r4k1/p4ppp/4p3/p5n1/4P3/1P1N1PPq/QB3b1P/R5K1 w - - 0 30",
        "Moves": "d3f2 g5f3 g1h1 h3h2",
        "Rating": 1019,
        "RatingDeviation": 75,
        "Popularity": 90,
        "NbPlays": 810,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/mJ2prRw1#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00TQf",
        "FEN": "4r1k1/p1R1n2p/4N3/5rK1/8/6PP/P3R3/8 w - - 3 46",
        "Moves": "g5g4 h7h5 g4h4 e7g6",
        "Rating": 1334,
        "RatingDeviation": 75,
        "Popularity": 97,
        "NbPlays": 519,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/aPLWBAFg#90",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00TRo",
        "FEN": "5q1k/2r3p1/1p2p2b/3p2NQ/3P4/1p6/5R2/6K1 b - - 1 38",
        "Moves": "f8b4 h5e8 b4f8 f2f8",
        "Rating": 1616,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 3356,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/h4dPcMj5/black#75",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00TU2",
        "FEN": "1k1r4/1p3Qp1/p2q3p/3N4/1b6/8/PP3PPP/2R3K1 w - - 4 22",
        "Moves": "d5b4 d6d1 c1d1 d8d1",
        "Rating": 508,
        "RatingDeviation": 81,
        "Popularity": 95,
        "NbPlays": 1181,
        "Themes": "backRankMate endgame mate mateIn2 sacrifice short",
        "GameUrl": "https://lichess.org/p32396Rd#42",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00V0G",
        "FEN": "8/6P1/5k1K/8/8/3p4/PR6/6r1 w - - 1 49",
        "Moves": "b2d2 g1h1 d2h2 h1h2",
        "Rating": 1133,
        "RatingDeviation": 77,
        "Popularity": 90,
        "NbPlays": 691,
        "Themes": "endgame mate mateIn2 rookEndgame short",
        "GameUrl": "https://lichess.org/UYjzL2st#96",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00VC1",
        "FEN": "1k2r3/p2r1R2/2Q5/1p5p/P1P3p1/8/6PP/7K w - - 2 44",
        "Moves": "c6d7 e8e1 f7f1 e1f1",
        "Rating": 439,
        "RatingDeviation": 117,
        "Popularity": 71,
        "NbPlays": 479,
        "Themes": "backRankMate endgame mate mateIn2 queenRookEndgame short",
        "GameUrl": "https://lichess.org/EjJXrCqs#86",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00VSe",
        "FEN": "6nr/1pN2ppp/p2Qbk2/2B1p3/3nq3/8/PP2BPPP/5K1R w - - 8 19",
        "Moves": "c5d4 e4b1 e2d1 b1d1",
        "Rating": 821,
        "RatingDeviation": 100,
        "Popularity": 94,
        "NbPlays": 491,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/xBVkshTD#36",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Lowenthal_Variation"
    },
    {
        "PuzzleId": "00Vdx",
        "FEN": "2k3rr/ppp2p1p/2np1B2/8/4P3/2NB1b2/PPP2PPP/R4RK1 w - - 1 13",
        "Moves": "f6h8 g8g2 g1h1 g2g4",
        "Rating": 1441,
        "RatingDeviation": 75,
        "Popularity": 91,
        "NbPlays": 246,
        "Themes": "discoveredAttack kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/z9NeMacX#24",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Busch-Gass_Gambit"
    },
    {
        "PuzzleId": "00WDP",
        "FEN": "1r2kb1r/p4ppp/Q1n5/2qpP1Bb/8/5N1P/P2N1PP1/R4RK1 b k - 2 16",
        "Moves": "b8b6 a6c8 c6d8 c8d8",
        "Rating": 1195,
        "RatingDeviation": 77,
        "Popularity": 89,
        "NbPlays": 475,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/8oXY3LOe/black#31",
        "OpeningTags": "Bishops_Opening Bishops_Opening_Ponziani_Gambit"
    },
    {
        "PuzzleId": "00WqT",
        "FEN": "r4r2/1ppb1p2/p2p2pk/5P2/4P3/2PBB1R1/PKP2P1q/8 b - - 4 26",
        "Moves": "h6h5 d3e2 h5h4 e3g5",
        "Rating": 1606,
        "RatingDeviation": 75,
        "Popularity": 97,
        "NbPlays": 14732,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/HcfiWViE/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Wyh",
        "FEN": "2r5/8/8/pNp1r2p/3kNppP/1P1P4/2R2K2/8 b - - 2 42",
        "Moves": "d4d3 c2d2 d3e4 b5d6",
        "Rating": 1753,
        "RatingDeviation": 77,
        "Popularity": 94,
        "NbPlays": 10458,
        "Themes": "endgame mate mateIn2 sacrifice short",
        "GameUrl": "https://lichess.org/2mLJufzX/black#83",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00XoP",
        "FEN": "6r1/p6k/1p4rp/3q1Q2/8/P7/4Rp1P/5R1K w - - 0 37",
        "Moves": "f5d5 g6g1 f1g1 f2g1q",
        "Rating": 694,
        "RatingDeviation": 86,
        "Popularity": 75,
        "NbPlays": 60,
        "Themes": "advancedPawn endgame mate mateIn2 promotion queenRookEndgame short",
        "GameUrl": "https://lichess.org/KLJMqvTZ#72",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Y1c",
        "FEN": "5rk1/Q4p2/5p1p/2q5/8/8/P1r2PPP/3RR1K1 w - - 4 23",
        "Moves": "a7d7 c5f2 g1h1 f2g2",
        "Rating": 839,
        "RatingDeviation": 85,
        "Popularity": 96,
        "NbPlays": 427,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/T4YH4yAb#44",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00YbZ",
        "FEN": "b6k/8/6p1/4q2p/1Q3r1P/P1N3R1/1PP3PK/8 w - - 3 35",
        "Moves": "b4b6 f4h4 h2g1 e5e1",
        "Rating": 1433,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 5078,
        "Themes": "endgame mate mateIn2 pin short",
        "GameUrl": "https://lichess.org/gzVgXweE#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Ydr",
        "FEN": "r2qkb1r/p2p2pb/1p1PpN2/2p1Pp2/2P2P1P/4K3/PP2B1P1/3Q3R b kq - 2 21",
        "Moves": "g7f6 e2h5 h7g6 h5g6",
        "Rating": 1076,
        "RatingDeviation": 89,
        "Popularity": 80,
        "NbPlays": 34,
        "Themes": "mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/3hQsr2bX/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Yey",
        "FEN": "r3kb1r/4ppp1/3q2p1/p2p4/Pp1Pn3/6N1/1PP1QPPP/R1B1R1K1 w kq - 4 17",
        "Moves": "g3e4 d6h2 g1f1 h2h1",
        "Rating": 955,
        "RatingDeviation": 81,
        "Popularity": 93,
        "NbPlays": 128,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/arVbaWDk#32",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Two_Knights_Attack"
    },
    {
        "PuzzleId": "00ZEc",
        "FEN": "1r3bk1/5p2/3P1qRP/r1n1p3/ppB5/P2Q1P2/1PP5/1K6 b - - 0 35",
        "Moves": "g8h7 g6g7 h7h6 d3h7",
        "Rating": 1798,
        "RatingDeviation": 74,
        "Popularity": 96,
        "NbPlays": 15608,
        "Themes": "doubleCheck mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/7IfLNNVB/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ZKw",
        "FEN": "rn1q1r1k/ppp5/1b2ppQ1/6B1/8/2P5/PP4PP/RN3R1K w - - 2 18",
        "Moves": "f1f6 d8d1 f6f1 f8f1",
        "Rating": 1017,
        "RatingDeviation": 96,
        "Popularity": 54,
        "NbPlays": 35,
        "Themes": "backRankMate mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/eyMv5HY5#34",
        "OpeningTags": "Kings_Gambit_Accepted Kings_Gambit_Accepted_Kings_Knights_Gambit"
    },
    {
        "PuzzleId": "00ZN7",
        "FEN": "3q2k1/8/Q2p2p1/3P1p1p/1p2P1nP/1Pp5/2P3P1/5R1K w - - 0 36",
        "Moves": "e4f5 d8h4 h1g1 h4h2",
        "Rating": 1009,
        "RatingDeviation": 75,
        "Popularity": 100,
        "NbPlays": 385,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/U0LXbVT4#70",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00ZWD",
        "FEN": "6k1/4bpp1/1q2p3/p2pP1N1/3P3P/1P1Q2K1/5P2/8 b - - 0 33",
        "Moves": "b6b4 d3h7 g8f8 h7h8",
        "Rating": 769,
        "RatingDeviation": 102,
        "Popularity": 94,
        "NbPlays": 277,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/2rMTqooF/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Zit",
        "FEN": "r3kb1r/ppp2pp1/3p4/1P2p3/2P3pn/2N1P2q/PB1P1P1N/R2Q1RK1 w kq - 0 15",
        "Moves": "d1g4 h4f3 h2f3 h3g4",
        "Rating": 1142,
        "RatingDeviation": 75,
        "Popularity": 90,
        "NbPlays": 525,
        "Themes": "deflection kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/3L9d0QhX#28",
        "OpeningTags": "Polish_Opening Polish_Opening_Czech_Defense"
    },
    {
        "PuzzleId": "00a98",
        "FEN": "4r1k1/p4p2/1p3q1p/1P6/3b2p1/P3B1P1/Q1P2PKP/4R3 w - - 0 32",
        "Moves": "e3d4 f6f3 g2f1 f3h1",
        "Rating": 1649,
        "RatingDeviation": 94,
        "Popularity": 81,
        "NbPlays": 19,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/pgdIGRB3#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00aBq",
        "FEN": "r2r2k1/pp3ppp/1qn2b2/3R4/4QB2/1P3N2/P4PPP/4R1K1 b - - 0 18",
        "Moves": "d8d5 e4e8 a8e8 e1e8",
        "Rating": 910,
        "RatingDeviation": 83,
        "Popularity": 88,
        "NbPlays": 317,
        "Themes": "backRankMate mate mateIn2 middlegame sacrifice short",
        "GameUrl": "https://lichess.org/0AybhVJm/black#35",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_London_System"
    },
    {
        "PuzzleId": "00aDl",
        "FEN": "r5k1/1p3p2/2p1ppp1/3p4/2nP4/1QB2B1P/rPP2PP1/qNKR3R w - - 3 22",
        "Moves": "f3e2 a1b1 c1b1 a2a1",
        "Rating": 1384,
        "RatingDeviation": 72,
        "Popularity": 95,
        "NbPlays": 26371,
        "Themes": "attraction mate mateIn2 middlegame queensideAttack sacrifice short",
        "GameUrl": "https://lichess.org/pc79SSEd#42",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00asK",
        "FEN": "2r3k1/R4ppp/8/4P3/4Q3/1qn3B1/5PPP/2R3K1 w - - 0 30",
        "Moves": "c1c3 b3d1 e4e1 d1e1",
        "Rating": 1460,
        "RatingDeviation": 87,
        "Popularity": 86,
        "NbPlays": 89,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/hlWKSG6i#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00bou",
        "FEN": "r1b1k1nr/pppp1ppp/3b4/3N2B1/3p4/8/PP1KBPPP/4R2R b kq - 3 11",
        "Moves": "f7f6 e2h5 e8f8 e1e8",
        "Rating": 1420,
        "RatingDeviation": 77,
        "Popularity": 77,
        "NbPlays": 145,
        "Themes": "doubleCheck mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/MIYxu2Dz/black#21",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_McConnell_Defense"
    },
    {
        "PuzzleId": "00bpH",
        "FEN": "8/5p2/pq5p/1p5k/6B1/6P1/P6P/2Q4K b - - 0 36",
        "Moves": "h5g4 c1f4 g4h5 f4f5",
        "Rating": 1882,
        "RatingDeviation": 77,
        "Popularity": 61,
        "NbPlays": 492,
        "Themes": "endgame mate mateIn2 queenEndgame short",
        "GameUrl": "https://lichess.org/vVLXcQQI/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00cxG",
        "FEN": "2r5/3RQ2p/6pk/8/5q1P/1P6/2K5/8 w - - 16 42",
        "Moves": "c2b2 f4c1 b2a2 c8c2",
        "Rating": 2056,
        "RatingDeviation": 92,
        "Popularity": 56,
        "NbPlays": 51,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/qctk0UXT#82",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00dpQ",
        "FEN": "6k1/5ppp/8/4rP2/1r4P1/2RK3P/8/7B b - - 0 47",
        "Moves": "b4b5 c3c8 e5e8 c8e8",
        "Rating": 400,
        "RatingDeviation": 113,
        "Popularity": 89,
        "NbPlays": 517,
        "Themes": "backRankMate endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/8DGDxXX7/black#93",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00eAX",
        "FEN": "6k1/ppprN1pp/8/8/2r5/2P5/P5PP/3R1RK1 b - - 5 26",
        "Moves": "d7e7 d1d8 e7e8 d8e8",
        "Rating": 788,
        "RatingDeviation": 75,
        "Popularity": 100,
        "NbPlays": 421,
        "Themes": "endgame mate mateIn2 rookEndgame short",
        "GameUrl": "https://lichess.org/MrdsMkpV/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00eCY",
        "FEN": "8/6p1/5p1p/R5kP/2b3P1/1r3PK1/8/8 b - - 4 61",
        "Moves": "c4d5 a5d5 f6f5 d5f5",
        "Rating": 601,
        "RatingDeviation": 86,
        "Popularity": 95,
        "NbPlays": 392,
        "Themes": "endgame hangingPiece mate mateIn2 short",
        "GameUrl": "https://lichess.org/LXHmo9rD/black#121",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00fgg",
        "FEN": "4r1k1/p4ppp/8/8/8/8/PP1b1PPP/K2R4 w - - 0 21",
        "Moves": "d1d2 e8e1 d2d1 e1d1",
        "Rating": 589,
        "RatingDeviation": 93,
        "Popularity": 63,
        "NbPlays": 192,
        "Themes": "backRankMate endgame mate mateIn2 rookEndgame short",
        "GameUrl": "https://lichess.org/AjVJZKD1#40",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00fwM",
        "FEN": "Qn1qk2r/p4ppp/2p5/2bn4/4pPb1/2N5/PPPP2PP/R1B1KBNR w KQk - 1 9",
        "Moves": "h2h3 d8h4 g2g3 h4g3",
        "Rating": 1271,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 3673,
        "Themes": "mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/REHlrlvo#16",
        "OpeningTags": "Kings_Gambit_Declined Kings_Gambit_Declined_Falkbeer_Countergambit"
    },
    {
        "PuzzleId": "00ghH",
        "FEN": "5r1k/6p1/1Q2pq1p/P4r2/3P4/2P1R3/6PP/4R1K1 w - - 1 39",
        "Moves": "d4d5 f5f1 e1f1 f6f1",
        "Rating": 644,
        "RatingDeviation": 80,
        "Popularity": 100,
        "NbPlays": 568,
        "Themes": "endgame mate mateIn2 short",
        "GameUrl": "https://lichess.org/ycQ7nVZM#76",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00h8Z",
        "FEN": "5k2/p1R4R/1p4p1/3r3q/3P4/2P2rQp/PP5K/8 b - - 4 36",
        "Moves": "f3g3 c7c8 d5d8 c8d8",
        "Rating": 1517,
        "RatingDeviation": 76,
        "Popularity": 81,
        "NbPlays": 130,
        "Themes": "endgame mate mateIn2 queenRookEndgame short",
        "GameUrl": "https://lichess.org/UAWACryx/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00hSr",
        "FEN": "r4rk1/5p2/1q2pnRP/p2p4/1ppP4/2P1P3/PPQN1P2/2K4R b - - 0 21",
        "Moves": "f7g6 c2g6 g8h8 g6g7",
        "Rating": 974,
        "RatingDeviation": 83,
        "Popularity": 94,
        "NbPlays": 5720,
        "Themes": "kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/FSHLYhgq/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00i7t",
        "FEN": "4r2k/p4r1p/2pp1Q2/2p5/3b1P2/3P2R1/PqPB2PP/4RK2 b - - 0 21",
        "Moves": "d4f6 e1e8 f7f8 e8f8",
        "Rating": 927,
        "RatingDeviation": 90,
        "Popularity": 84,
        "NbPlays": 145,
        "Themes": "hangingPiece kingsideAttack mate mateIn2 middlegame short",
        "GameUrl": "https://lichess.org/fBWee6U4/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0000D",
        "FEN": "5rk1/1p3ppp/pq3b2/8/8/1P1Q1N2/P4PPP/3R2K1 w - - 2 27",
        "Moves": "d3d6 f8d8 d6d8 f6d8",
        "Rating": 1429,
        "RatingDeviation": 73,
        "Popularity": 96,
        "NbPlays": 26521,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/F8M8OS71#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0008Q",
        "FEN": "8/4R3/1p2P3/p4r2/P6p/1P3Pk1/4K3/8 w - - 1 64",
        "Moves": "e7f7 f5e5 e2f1 e5e6",
        "Rating": 1419,
        "RatingDeviation": 75,
        "Popularity": 90,
        "NbPlays": 560,
        "Themes": "advantage endgame rookEndgame short",
        "GameUrl": "https://lichess.org/MQSyb3KW#126",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0009B",
        "FEN": "r2qr1k1/b1p2ppp/pp4n1/P1P1p3/4P1n1/B2P2Pb/3NBP1P/RN1QR1K1 b - - 1 16",
        "Moves": "b6c5 e2g4 h3g4 d1g4",
        "Rating": 1112,
        "RatingDeviation": 74,
        "Popularity": 87,
        "NbPlays": 569,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/4MWQCxQ6/black#31",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Leonardis_Variation"
    },
    {
        "PuzzleId": "000aY",
        "FEN": "r4rk1/pp3ppp/2n1b3/q1pp2B1/8/P1Q2NP1/1PP1PP1P/2KR3R w - - 0 15",
        "Moves": "g5e7 a5c3 b2c3 c6e7",
        "Rating": 1428,
        "RatingDeviation": 79,
        "Popularity": 73,
        "NbPlays": 505,
        "Themes": "advantage master middlegame short",
        "GameUrl": "https://lichess.org/iihZGl6t#28",
        "OpeningTags": "Benoni_Defense Benoni_Defense_Benoni-Indian_Defense"
    },
    {
        "PuzzleId": "000lC",
        "FEN": "3r3r/pQNk1ppp/1qnb1n2/1B6/8/8/PPP3PP/3R1R1K w - - 5 19",
        "Moves": "d1d6 d7d6 b7b6 a7b6",
        "Rating": 1501,
        "RatingDeviation": 75,
        "Popularity": 97,
        "NbPlays": 1039,
        "Themes": "advantage hangingPiece middlegame short",
        "GameUrl": "https://lichess.org/vaqz2bx6#36",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00143",
        "FEN": "r2q1rk1/5ppp/1np5/p1b5/2p1B3/P7/1P3PPP/R1BQ1RK1 b - - 1 17",
        "Moves": "d8f6 d1h5 h7h6 h5c5",
        "Rating": 1815,
        "RatingDeviation": 74,
        "Popularity": 91,
        "NbPlays": 2472,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/jcuxlI63/black#33",
        "OpeningTags": "Scotch_Game Scotch_Game_Mieses_Variation"
    },
    {
        "PuzzleId": "0018S",
        "FEN": "2kr3r/pp3p2/4p2p/1N1p2p1/3Q4/1P1P4/2q2PPP/5RK1 b - - 1 20",
        "Moves": "b7b6 d4a1 a7a5 f1c1",
        "Rating": 2581,
        "RatingDeviation": 117,
        "Popularity": 90,
        "NbPlays": 1640,
        "Themes": "advantage endgame pin short",
        "GameUrl": "https://lichess.org/H1ARO2GL/black#39",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001m3",
        "FEN": "7r/6k1/2b1pp2/8/P1N3p1/5nP1/4RP2/Q4K2 w - - 2 38",
        "Moves": "e2e6 h8h1 f1e2 h1a1",
        "Rating": 1497,
        "RatingDeviation": 75,
        "Popularity": 87,
        "NbPlays": 265,
        "Themes": "advantage endgame short skewer",
        "GameUrl": "https://lichess.org/LELOz22f#74",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001u3",
        "FEN": "2r3k1/p1q2pp1/Q3p2p/b1Np4/2nP1P2/4P1P1/5K1P/2B1N3 b - - 3 33",
        "Moves": "c7b6 a6c8 g8h7 c8b7",
        "Rating": 2175,
        "RatingDeviation": 81,
        "Popularity": 55,
        "NbPlays": 77,
        "Themes": "advantage hangingPiece middlegame short",
        "GameUrl": "https://lichess.org/BBn6ipaK/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001uD",
        "FEN": "6k1/1p3pp1/1p5p/2r1p3/2n5/r3PN2/2RnNPPP/2R3K1 b - - 1 32",
        "Moves": "f7f6 f3d2 c4d2 c2d2 c5c1 e2c1",
        "Rating": 1799,
        "RatingDeviation": 74,
        "Popularity": 92,
        "NbPlays": 674,
        "Themes": "advantage long middlegame",
        "GameUrl": "https://lichess.org/2qkVLUl6/black#63",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001wr",
        "FEN": "r4rk1/p3ppbp/Pp1q1np1/3PpbB1/2B5/2N5/1PPQ1PPP/3RR1K1 w - - 4 18",
        "Moves": "f2f3 d6c5 g1h1 c5c4",
        "Rating": 924,
        "RatingDeviation": 75,
        "Popularity": 96,
        "NbPlays": 1839,
        "Themes": "advantage fork master masterVsMaster middlegame short",
        "GameUrl": "https://lichess.org/KnJ2mojX#34",
        "OpeningTags": "Pirc_Defense Pirc_Defense_Classical_Variation"
    },
    {
        "PuzzleId": "001xl",
        "FEN": "8/4R1k1/p5pp/3B4/5q2/8/5P1P/6K1 b - - 5 40",
        "Moves": "g7f6 e7f7 f6e5 f7f4",
        "Rating": 1042,
        "RatingDeviation": 77,
        "Popularity": 94,
        "NbPlays": 10907,
        "Themes": "advantage endgame master masterVsMaster short skewer superGM",
        "GameUrl": "https://lichess.org/bEQkfPQD/black#79",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00206",
        "FEN": "r3kb1r/pppqpn1p/5p2/3p1bpQ/2PP4/4P1B1/PP3PPP/RN2KB1R w KQkq - 1 11",
        "Moves": "b1c3 f5g4 h5g4 d7g4",
        "Rating": 1712,
        "RatingDeviation": 73,
        "Popularity": 96,
        "NbPlays": 25989,
        "Themes": "advantage opening short trappedPiece",
        "GameUrl": "https://lichess.org/MbJRo6PT#20",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Accelerated_London_System"
    },
    {
        "PuzzleId": "002IE",
        "FEN": "r3brk1/5pp1/p1nqpn1p/P2pN3/2pP4/2P1PN2/5PPP/RB1QK2R b KQ - 4 16",
        "Moves": "c6e5 d4e5 d6e7 e5f6",
        "Rating": 1212,
        "RatingDeviation": 89,
        "Popularity": 60,
        "NbPlays": 27,
        "Themes": "advantage fork middlegame short",
        "GameUrl": "https://lichess.org/fDwvVUIp/black#31",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Accelerated_London_System"
    },
    {
        "PuzzleId": "002LF",
        "FEN": "7r/p2q1pk1/1pp3p1/8/6P1/4Q3/PP1R1P1r/5KN1 b - - 0 38",
        "Moves": "d7g4 e3e5 f7f6 e5c7 g7h6 c7h2",
        "Rating": 2233,
        "RatingDeviation": 79,
        "Popularity": 88,
        "NbPlays": 358,
        "Themes": "advantage endgame interference long",
        "GameUrl": "https://lichess.org/md88dHiL/black#75",
        "OpeningTags": null
    },
    {
        "PuzzleId": "002LW",
        "FEN": "3r1rk1/1b1n1pp1/3p4/p4PPQ/4P3/3q1BN1/8/2R2RK1 b - - 1 28",
        "Moves": "d7e5 f5f6 e5f3 f1f3",
        "Rating": 2464,
        "RatingDeviation": 88,
        "Popularity": 78,
        "NbPlays": 112,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/0khwj5dv/black#55",
        "OpeningTags": null
    },
    {
        "PuzzleId": "002Tf",
        "FEN": "r3kbnr/ppp1qppp/2n5/3pP3/5B2/4PQ2/PPP2PPP/RN2KB1R w KQkq - 1 7",
        "Moves": "f1b5 e7b4 b1c3 b4b2",
        "Rating": 1575,
        "RatingDeviation": 75,
        "Popularity": 83,
        "NbPlays": 164,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/Zq56PwHK#12",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Chigorin_Variation"
    },
    {
        "PuzzleId": "002bK",
        "FEN": "8/7p/2b1k3/p2p1pPB/1n1P3P/N1p1P3/4K3/8 b - - 1 42",
        "Moves": "c6b5 a3b5 c3c2 e2d2",
        "Rating": 1171,
        "RatingDeviation": 76,
        "Popularity": 93,
        "NbPlays": 749,
        "Themes": "advantage endgame hangingPiece short",
        "GameUrl": "https://lichess.org/IFGj8W5s/black#83",
        "OpeningTags": null
    },
    {
        "PuzzleId": "002uV",
        "FEN": "r2r2k1/1p2qppp/2n1p3/5n2/p2P4/P2Q1N2/BP3PPP/2R1R1K1 w - - 4 20",
        "Moves": "d3f5 e6f5 e1e7 c6e7",
        "Rating": 1615,
        "RatingDeviation": 76,
        "Popularity": 85,
        "NbPlays": 65,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/WKH5eIti#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003Jb",
        "FEN": "6k1/3bqr1p/2rpp1pR/p7/Pp1QP3/1B3P2/1PP3P1/2KR4 w - - 6 22",
        "Moves": "d4a7 e7g5 c1b1 g5h6",
        "Rating": 996,
        "RatingDeviation": 79,
        "Popularity": 90,
        "NbPlays": 387,
        "Themes": "advantage fork middlegame short",
        "GameUrl": "https://lichess.org/8RvK0idj#42",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003S3",
        "FEN": "r4k1r/pNqnppb1/6pn/2p3Np/7P/2P2Q2/PP3PP1/R1B1K2R b KQ - 2 15",
        "Moves": "a8b8 g5e6 f8g8 e6c7",
        "Rating": 1424,
        "RatingDeviation": 75,
        "Popularity": 96,
        "NbPlays": 5280,
        "Themes": "advantage middlegame pin short",
        "GameUrl": "https://lichess.org/Eu6S0GPA/black#29",
        "OpeningTags": "Modern_Defense Modern_Defense_Other_variations"
    },
    {
        "PuzzleId": "003UW",
        "FEN": "8/6pk/7p/2p5/2qp4/5PP1/P3QK1P/8 b - - 1 40",
        "Moves": "c4d5 e2e4 d5e4 f3e4",
        "Rating": 1438,
        "RatingDeviation": 75,
        "Popularity": 92,
        "NbPlays": 580,
        "Themes": "advantage endgame queenEndgame short",
        "GameUrl": "https://lichess.org/cXMga3rb/black#79",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003YT",
        "FEN": "r1bqk1nr/1pp2ppp/p1pb4/4p3/3PP3/5N2/PPP2PPP/RNBQ1RK1 b kq - 0 6",
        "Moves": "d8f6 d4e5 d6e5 c1g5 f6d6 f3e5 d6d1 f1d1",
        "Rating": 1729,
        "RatingDeviation": 167,
        "Popularity": -60,
        "NbPlays": 15,
        "Themes": "advantage fork opening veryLong",
        "GameUrl": "https://lichess.org/TAffogpQ/black#11",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Exchange_Variation"
    },
    {
        "PuzzleId": "003o0",
        "FEN": "r1bqk2r/pp1nbppp/3p4/1B1p4/3P1B2/8/PPP2PPP/R2QK1NR w KQkq - 2 9",
        "Moves": "g1f3 d8a5 d1d2 a5b5",
        "Rating": 1030,
        "RatingDeviation": 80,
        "Popularity": 90,
        "NbPlays": 650,
        "Themes": "advantage fork master opening short",
        "GameUrl": "https://lichess.org/Ae0t9V1Z#16",
        "OpeningTags": "Czech_Defense Czech_Defense_Other_variations"
    },
    {
        "PuzzleId": "003wQ",
        "FEN": "2r2rk1/6pp/3Q1q2/8/3N1B2/6P1/PP1K3P/R4b2 w - - 0 24",
        "Moves": "a1f1 f6d6 f4d6 f8f1",
        "Rating": 1881,
        "RatingDeviation": 76,
        "Popularity": 91,
        "NbPlays": 1691,
        "Themes": "advantage discoveredAttack middlegame pin short",
        "GameUrl": "https://lichess.org/W3wvnzlo#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0045Q",
        "FEN": "rnbqkb1r/pppp2pp/8/4P3/2B5/4p3/PPPP2PP/R1BQK1NR w KQkq - 0 7",
        "Moves": "d1f3 d8h4 e1d1 h4c4",
        "Rating": 1463,
        "RatingDeviation": 79,
        "Popularity": 97,
        "NbPlays": 24108,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/fTegzZIT#12",
        "OpeningTags": "Vienna_Game Vienna_Game_Other_variations"
    },
    {
        "PuzzleId": "004Ao",
        "FEN": "4qk2/1b3rR1/p7/1p2Q3/4P2P/P2P3K/2r5/3R4 w - - 5 41",
        "Moves": "g7f7 e8f7 e5h8 f8e7",
        "Rating": 1735,
        "RatingDeviation": 99,
        "Popularity": 86,
        "NbPlays": 19,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/aFlzjb1K#80",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004BW",
        "FEN": "r1bk2r1/ppq2pQp/3bpn2/1BpnN3/5P2/1P6/PBPP2PP/RN2K2R w KQ - 3 13",
        "Moves": "e5f7 d8e7 g7g8 f6g8",
        "Rating": 1724,
        "RatingDeviation": 76,
        "Popularity": 91,
        "NbPlays": 1280,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/EXlG6TZs#24",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Modern_Variations"
    },
    {
        "PuzzleId": "004Ys",
        "FEN": "r4rk1/3q1pbp/p1n1p1p1/2p3NP/1p3B2/3P3Q/PPP3P1/R3R1K1 b - - 2 19",
        "Moves": "d7d4 f4e3 d4f6 e1f1 f6e5 h5g6 e5e3 h3e3",
        "Rating": 2282,
        "RatingDeviation": 82,
        "Popularity": 88,
        "NbPlays": 277,
        "Themes": "advantage defensiveMove middlegame veryLong",
        "GameUrl": "https://lichess.org/LcIJdugn/black#37",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_McDonnell_Attack"
    },
    {
        "PuzzleId": "004mT",
        "FEN": "5Q2/8/1b1kp1p1/5p2/3p4/5qPK/7P/8 b - - 1 51",
        "Moves": "d6c6 f8a8 c6d6 a8f3",
        "Rating": 1406,
        "RatingDeviation": 74,
        "Popularity": 99,
        "NbPlays": 1645,
        "Themes": "advantage endgame short skewer",
        "GameUrl": "https://lichess.org/Jqhi4ozb/black#101",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004sg",
        "FEN": "6k1/p3b2p/1p1pP3/2p3P1/1Pnp3B/P6P/3Q3K/8 w - - 0 38",
        "Moves": "b4c5 c4d2 c5c6 d6d5 g5g6 e7d6",
        "Rating": 2361,
        "RatingDeviation": 84,
        "Popularity": 90,
        "NbPlays": 1091,
        "Themes": "advantage clearance endgame hangingPiece long quietMove",
        "GameUrl": "https://lichess.org/pSRIvt7K#74",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004u0",
        "FEN": "6k1/ppq3pp/2p1rp2/4r3/4p1Q1/P5RP/1P3PP1/3R2K1 b - - 3 34",
        "Moves": "e6e8 d1d7 c7d7 g4d7",
        "Rating": 1387,
        "RatingDeviation": 76,
        "Popularity": 92,
        "NbPlays": 831,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/3gEqoQeQ/black#67",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0055Y",
        "FEN": "r1b2rk1/p3pp2/2B4b/2Qpq3/3N2pp/4P3/2P2PPP/1R2K2R b K - 1 23",
        "Moves": "h6e3 f2e3 e5e3 e1d1",
        "Rating": 2055,
        "RatingDeviation": 76,
        "Popularity": 79,
        "NbPlays": 144,
        "Themes": "advantage defensiveMove middlegame short",
        "GameUrl": "https://lichess.org/7Jpwzowt/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005jJ",
        "FEN": "r1b1qrk1/pp1n1pbp/2pp1np1/4p3/2PP1B2/2NBPN1P/PP3PP1/R2Q1RK1 w - - 0 10",
        "Moves": "d4e5 d6e5 f4h2 e5e4",
        "Rating": 1242,
        "RatingDeviation": 83,
        "Popularity": 70,
        "NbPlays": 29,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/wt6Q2xGb#18",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Other_variations"
    },
    {
        "PuzzleId": "005yO",
        "FEN": "r1r3k1/ppq3bQ/4p2p/4n3/3p4/2P5/PBB2PPP/4R1K1 b - - 2 24",
        "Moves": "g8f8 b2a3 f8f7 c2d1 c8h8 d1h5 f7f6 h7e4",
        "Rating": 2795,
        "RatingDeviation": 101,
        "Popularity": 88,
        "NbPlays": 202,
        "Themes": "advantage exposedKing middlegame quietMove veryLong",
        "GameUrl": "https://lichess.org/j65YI8hC/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0066C",
        "FEN": "r2q1r1k/2p3p1/pb2Q2p/1p1p1n2/8/1BP5/PP1B1PPP/3RR1K1 w - - 3 20",
        "Moves": "b3d5 b6f2 g1f2 f5d4 f2g1 d4e6",
        "Rating": 1768,
        "RatingDeviation": 78,
        "Popularity": 81,
        "NbPlays": 138,
        "Themes": "advantage discoveredAttack kingsideAttack long middlegame sacrifice",
        "GameUrl": "https://lichess.org/ZyuTEP3l#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "006NL",
        "FEN": "1r6/k2qn1b1/p1b1p1p1/2PpPpN1/2nN1P1P/p4B2/1PP2Q2/1K1R3R w - - 0 32",
        "Moves": "d4c6 e7c6 b2b3 a3a2 b1a1 c4e5 f4e5 g7e5 a1a2 b8b5",
        "Rating": 2543,
        "RatingDeviation": 88,
        "Popularity": 84,
        "NbPlays": 88,
        "Themes": "advancedPawn advantage middlegame pin veryLong",
        "GameUrl": "https://lichess.org/yA3M5Q6W#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "006XF",
        "FEN": "r5kr/pp1qb1p1/2p4p/3pPb1Q/3P4/2P1B3/PP4PP/R4RK1 b - - 1 17",
        "Moves": "f5e4 h5f7 g8h7 f1f6 e7f6 f7d7",
        "Rating": 2264,
        "RatingDeviation": 81,
        "Popularity": 90,
        "NbPlays": 1776,
        "Themes": "advantage long middlegame pin",
        "GameUrl": "https://lichess.org/Ynra1LLE/black#33",
        "OpeningTags": "Russian_Game Russian_Game_Italian_Variation"
    },
    {
        "PuzzleId": "006cZ",
        "FEN": "3r1rk1/1p4p1/p1p3Qp/2q5/8/3n1N1P/PP1R2P1/5R1K b - - 7 28",
        "Moves": "g8h8 d2d3 d8d3 g6d3",
        "Rating": 1281,
        "RatingDeviation": 75,
        "Popularity": 88,
        "NbPlays": 617,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/qrbDEp56/black#55",
        "OpeningTags": null
    },
    {
        "PuzzleId": "006fF",
        "FEN": "r1b4r/pp1k2pp/2nb2q1/1B1p2B1/3p3Q/8/PPP2PPP/3RR1K1 b - - 5 17",
        "Moves": "h7h6 h4g4 d7c7 g5d8 h8d8 g4g6",
        "Rating": 1966,
        "RatingDeviation": 75,
        "Popularity": 96,
        "NbPlays": 2914,
        "Themes": "advantage discoveredAttack exposedKing long middlegame",
        "GameUrl": "https://lichess.org/mAf9SSin/black#33",
        "OpeningTags": "Italian_Game Italian_Game_Two_Knights_Defense"
    },
    {
        "PuzzleId": "006ia",
        "FEN": "1r4k1/4bpp1/1rp2n1p/3p4/3P4/2N1B1P1/Pq2QPKP/2R1R3 w - - 3 24",
        "Moves": "e3h6 b2e2 e1e2 e7a3 h6e3 a3c1",
        "Rating": 2119,
        "RatingDeviation": 146,
        "Popularity": 68,
        "NbPlays": 6,
        "Themes": "advantage long middlegame",
        "GameUrl": "https://lichess.org/fcKXrUhC#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "006of",
        "FEN": "r2qr2k/1pp2pp1/1b4np/pP2P3/P4n2/BQN2N1P/5PP1/R3R1K1 w - - 3 20",
        "Moves": "b3f7 d8d3 c3e2 f4e2 e1e2 d3e2",
        "Rating": 2520,
        "RatingDeviation": 96,
        "Popularity": 88,
        "NbPlays": 821,
        "Themes": "advantage kingsideAttack long middlegame",
        "GameUrl": "https://lichess.org/MIdWd89x#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0070J",
        "FEN": "r4rk1/ppq2ppp/2nbp1b1/3p4/3Pn3/2PB1N1P/PP3PP1/R1BQRNK1 b - - 4 14",
        "Moves": "e4f2 g1f2 g6d3 d1d3",
        "Rating": 1025,
        "RatingDeviation": 91,
        "Popularity": 60,
        "NbPlays": 80,
        "Themes": "advantage hangingPiece middlegame short",
        "GameUrl": "https://lichess.org/SHqFVu02/black#27",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Exchange_Variation"
    },
    {
        "PuzzleId": "0072T",
        "FEN": "3q1nk1/1bN2rpp/pp1P4/1N6/4n2b/8/PPP2PPP/R1BQ1RK1 w - - 1 16",
        "Moves": "b5d4 h4f2 f1f2 e4f2",
        "Rating": 2381,
        "RatingDeviation": 77,
        "Popularity": 85,
        "NbPlays": 470,
        "Themes": "advantage kingsideAttack master middlegame short",
        "GameUrl": "https://lichess.org/aqhibPRF#30",
        "OpeningTags": "Philidor_Defense Philidor_Defense_Lion_Variation"
    },
    {
        "PuzzleId": "007eS",
        "FEN": "6k1/p4p2/1p5p/4r3/P3B3/1P3P2/2PK2PP/8 w - - 0 29",
        "Moves": "d2e3 f7f5 g2g4 f5e4",
        "Rating": 1240,
        "RatingDeviation": 74,
        "Popularity": 97,
        "NbPlays": 9481,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/8qs8bafy#56",
        "OpeningTags": null
    },
    {
        "PuzzleId": "007tv",
        "FEN": "r3k1nr/1pp2ppp/1pnp2q1/4p1B1/2B1P3/3P1Q1P/PPP2PP1/R4RK1 b kq - 0 11",
        "Moves": "g6g5 f3f7 e8d8 f7f8 d8d7 f8a8",
        "Rating": 1308,
        "RatingDeviation": 75,
        "Popularity": 92,
        "NbPlays": 1035,
        "Themes": "advantage attackingF2F7 long middlegame skewer",
        "GameUrl": "https://lichess.org/ky7qZNjk/black#21",
        "OpeningTags": "Italian_Game Italian_Game_Giuoco_Pianissimo"
    },
    {
        "PuzzleId": "008D5",
        "FEN": "r1bqk2r/pp3ppp/4p2n/3pP3/1b1P1P2/2N5/PP4PP/R1BQKB1R b KQkq - 2 9",
        "Moves": "h6f5 d1a4 c8d7 a4b4",
        "Rating": 1419,
        "RatingDeviation": 75,
        "Popularity": 81,
        "NbPlays": 1176,
        "Themes": "advantage fork master opening short",
        "GameUrl": "https://lichess.org/jIGC2FuP/black#17",
        "OpeningTags": "French_Defense French_Defense_La_Bourdonnais_Variation"
    },
    {
        "PuzzleId": "008Y3",
        "FEN": "r5k1/1p1rqpp1/p3pnp1/2PN4/8/1Q5P/PP3PP1/3RR1K1 b - - 0 24",
        "Moves": "e7c5 d5f6 g7f6 d1d7",
        "Rating": 1142,
        "RatingDeviation": 75,
        "Popularity": 100,
        "NbPlays": 173,
        "Themes": "advantage discoveredAttack kingsideAttack middlegame short",
        "GameUrl": "https://lichess.org/jAILX5BH/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0095W",
        "FEN": "8/pp1r2kp/q2P1ppb/4p3/2N1P3/1Q5P/PPR2PP1/6K1 w - - 3 32",
        "Moves": "c4e5 f6e5 c2c7 a6d6",
        "Rating": 1888,
        "RatingDeviation": 75,
        "Popularity": 98,
        "NbPlays": 595,
        "Themes": "advantage endgame hangingPiece short",
        "GameUrl": "https://lichess.org/CaL8Bl7F#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009De",
        "FEN": "r1q4r/2p1kP2/3p4/2pPp3/p1P1Pb2/P1NB3b/1P3KP1/R2Q1R2 w - - 1 23",
        "Moves": "g2h3 c8h3 d1f3 h3h2 f3g2 f4e3 f2f3 h8h3 g2h3 h2h3",
        "Rating": 1925,
        "RatingDeviation": 80,
        "Popularity": 79,
        "NbPlays": 50,
        "Themes": "advantage exposedKing middlegame veryLong",
        "GameUrl": "https://lichess.org/PsMgMg87#44",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00AHY",
        "FEN": "r6k/3NR1p1/4n2p/5b2/p6P/6R1/8/6K1 w - - 2 43",
        "Moves": "h4h5 a4a3 g3a3 a8a3 e7e8 h8h7",
        "Rating": 1358,
        "RatingDeviation": 78,
        "Popularity": 84,
        "NbPlays": 1510,
        "Themes": "advantage endgame long",
        "GameUrl": "https://lichess.org/SFxNjHBp#84",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00AOH",
        "FEN": "6k1/1R6/1p2p1pp/4P3/p1N2P2/6PK/7P/1r6 w - - 0 48",
        "Moves": "b7b6 b1b6 c4b6 a4a3 b6d7 a3a2",
        "Rating": 864,
        "RatingDeviation": 80,
        "Popularity": 95,
        "NbPlays": 644,
        "Themes": "advancedPawn advantage endgame long",
        "GameUrl": "https://lichess.org/D6NQDAPE#94",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00AXb",
        "FEN": "5kr1/pp3p1p/1q2pBb1/1B1p4/P7/5P2/1P4rP/2Q1K2R b K - 0 21",
        "Moves": "g2g1 h1g1 b6g1 b5f1 g6c2 c1f4",
        "Rating": 2115,
        "RatingDeviation": 132,
        "Popularity": 82,
        "NbPlays": 19,
        "Themes": "advantage defensiveMove long middlegame",
        "GameUrl": "https://lichess.org/4i5kxYT5/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Ac7",
        "FEN": "8/2p1pk1p/Pp4p1/8/p1P2P2/3r2P1/3PR2P/3K4 b - - 1 33",
        "Moves": "a4a3 a6a7 d3d8 e2e3 a3a2 e3a3",
        "Rating": 2362,
        "RatingDeviation": 78,
        "Popularity": 98,
        "NbPlays": 424,
        "Themes": "advancedPawn advantage endgame long rookEndgame",
        "GameUrl": "https://lichess.org/SIcsTksL/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00AhO",
        "FEN": "r1b2rk1/2q2p1p/1p2pbp1/pP6/2P1Q3/P2B1N2/5PPP/3R1RK1 w - - 0 20",
        "Moves": "e4a8 c8b7 a8a7 f8a8 a7a8 b7a8",
        "Rating": 1182,
        "RatingDeviation": 75,
        "Popularity": 96,
        "NbPlays": 368,
        "Themes": "advantage clearance long middlegame trappedPiece",
        "GameUrl": "https://lichess.org/9PjjgfVE#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Al5",
        "FEN": "2r3k1/p2q1pbp/1p2pnp1/nB1p4/3P4/1Pr1P2P/P1QB1PP1/2R2RK1 w - - 0 19",
        "Moves": "b5d7 c3c2 d7c8 c2d2",
        "Rating": 1641,
        "RatingDeviation": 75,
        "Popularity": 97,
        "NbPlays": 6731,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/EtyflSie#36",
        "OpeningTags": "Slav_Defense Slav_Defense_Schlechter_Variation"
    },
    {
        "PuzzleId": "00AoZ",
        "FEN": "8/1R6/p1pk4/6bp/1QP5/P7/KP6/3r2q1 b - - 2 44",
        "Moves": "g1c5 b7d7 d6d7 b4c5",
        "Rating": 1012,
        "RatingDeviation": 80,
        "Popularity": 93,
        "NbPlays": 3362,
        "Themes": "advantage deflection endgame short",
        "GameUrl": "https://lichess.org/356BAYqk/black#87",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00B5A",
        "FEN": "r2qk2r/ppp2ppp/2n1b3/1B1N4/3b4/3P3P/P1P1QPP1/1R2K1NR w Kkq - 4 13",
        "Moves": "g1f3 d8d5 f3d4 d5d4 b5c6 b7c6",
        "Rating": 1492,
        "RatingDeviation": 74,
        "Popularity": 94,
        "NbPlays": 14217,
        "Themes": "advantage hangingPiece long middlegame",
        "GameUrl": "https://lichess.org/JCYgLgB2#24",
        "OpeningTags": "Nimzowitsch_Defense Nimzowitsch_Defense_Other_variations"
    },
    {
        "PuzzleId": "00BKa",
        "FEN": "5rk1/p1Rb1ppp/2n1pn2/8/8/2P3P1/q4PBP/1rNQK2R b K - 2 16",
        "Moves": "f8c8 c7c8 d7c8 c1a2 b1d1 e1d1",
        "Rating": 2502,
        "RatingDeviation": 83,
        "Popularity": 90,
        "NbPlays": 824,
        "Themes": "advantage long middlegame",
        "GameUrl": "https://lichess.org/0bBHtpd4/black#31",
        "OpeningTags": "French_Defense French_Defense_Winawer_Variation"
    },
    {
        "PuzzleId": "00BM8",
        "FEN": "r4rk1/pp2bppp/2ppnn2/8/N1P1P3/q1P4P/P2N2PB/R2Q1R1K b - - 0 16",
        "Moves": "a8d8 d2b1 a3a4 d1a4",
        "Rating": 1615,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 6813,
        "Themes": "advantage master middlegame short trappedPiece",
        "GameUrl": "https://lichess.org/IBbaWSo7/black#31",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Other_variations"
    },
    {
        "PuzzleId": "00BSo",
        "FEN": "2r3k1/4R1pp/p1p2p2/2p5/2P5/1PbN3P/P4PP1/6K1 w - - 0 25",
        "Moves": "d3c5 c3b4 e7a7 b4c5",
        "Rating": 1198,
        "RatingDeviation": 78,
        "Popularity": 93,
        "NbPlays": 780,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/SjQSgSG9#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Bp0",
        "FEN": "1r2kr2/pp3p1p/2b1pn2/4N3/2P5/1N1B4/P3KP1P/6R1 b - - 4 21",
        "Moves": "f6e4 e5c6 b7c6 d3e4",
        "Rating": 1201,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 8511,
        "Themes": "advantage capturingDefender middlegame short",
        "GameUrl": "https://lichess.org/GN8F9TsL/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Bul",
        "FEN": "rnbqk2r/pp3ppp/5n2/3pN3/2B5/2P5/P1PPQPPP/R1B1K2R b KQkq - 1 8",
        "Moves": "d5c4 e5c6 c8e6 c6d8",
        "Rating": 1254,
        "RatingDeviation": 75,
        "Popularity": 91,
        "NbPlays": 594,
        "Themes": "advantage discoveredAttack opening short",
        "GameUrl": "https://lichess.org/70pObIpq/black#15",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Gunderam_Gambit"
    },
    {
        "PuzzleId": "00CXr",
        "FEN": "r2k2nr/pp2qBb1/3p3p/Q5p1/3n1B2/2N2R2/PPP3P1/R5K1 b - - 1 18",
        "Moves": "b7b6 a5d5 d4f3 g2f3 a8c8 f4d6",
        "Rating": 1909,
        "RatingDeviation": 75,
        "Popularity": 91,
        "NbPlays": 1576,
        "Themes": "advantage long middlegame sacrifice",
        "GameUrl": "https://lichess.org/sr8OoFsx/black#35",
        "OpeningTags": "Kings_Gambit_Accepted Kings_Gambit_Accepted_Fischer_Defense"
    },
    {
        "PuzzleId": "00Cs4",
        "FEN": "2r1q1k1/8/b2b1r1p/Pp1pNpp1/3Pn3/1RPQ3P/P1B1NPP1/4R1K1 w - - 3 28",
        "Moves": "a2a4 b5a4 d3a6 a4b3",
        "Rating": 1388,
        "RatingDeviation": 86,
        "Popularity": 85,
        "NbPlays": 63,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/fswqBBFw#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00DdW",
        "FEN": "5rk1/4bppp/4b3/1p1pPpPP/2pP4/2P5/rqNQKP2/2RRN3 b - - 5 23",
        "Moves": "e7a3 c1b1 b2b3 b1b3",
        "Rating": 1659,
        "RatingDeviation": 74,
        "Popularity": 86,
        "NbPlays": 771,
        "Themes": "advantage middlegame short trappedPiece",
        "GameUrl": "https://lichess.org/bT7kcwFH/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00E4Z",
        "FEN": "1r4k1/p4p1p/6p1/3rb3/K7/2PpB3/1P1R1PPP/7R w - - 1 25",
        "Moves": "h1d1 d5d6 b2b4 e5c3 e3c5 d6a6",
        "Rating": 2290,
        "RatingDeviation": 81,
        "Popularity": 84,
        "NbPlays": 161,
        "Themes": "advantage endgame long master masterVsMaster quietMove",
        "GameUrl": "https://lichess.org/YRE2uOtG#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00EDN",
        "FEN": "rnbq1rk1/p4ppp/1p2p3/2p5/2QPn3/2P1PN2/P3BPPP/R1B2RK1 w - - 0 11",
        "Moves": "c1a3 c8a6 c4a6 b8a6",
        "Rating": 1656,
        "RatingDeviation": 84,
        "Popularity": 76,
        "NbPlays": 34,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/clViyZ2d#20",
        "OpeningTags": "Nimzo-Indian_Defense Nimzo-Indian_Defense_Normal_Variation"
    },
    {
        "PuzzleId": "00EJb",
        "FEN": "6k1/5pp1/2R1p2p/8/P1B5/1P4P1/1q3Q1P/3r2K1 w - - 1 35",
        "Moves": "g1g2 d1d2 c6c8 g8h7 c4d3 f7f5 c8c2 d2f2",
        "Rating": 2281,
        "RatingDeviation": 80,
        "Popularity": 87,
        "NbPlays": 436,
        "Themes": "advantage endgame pin veryLong",
        "GameUrl": "https://lichess.org/ki9WEgCM#68",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00EXS",
        "FEN": "r3r1k1/p2Q1p1p/1p2p1p1/8/1P1P4/P3P3/1B2Nb1q/2KR1R2 w - - 0 19",
        "Moves": "f1h1 f2e3 c1b1 h2e2",
        "Rating": 1579,
        "RatingDeviation": 85,
        "Popularity": 56,
        "NbPlays": 29,
        "Themes": "advantage discoveredAttack middlegame short",
        "GameUrl": "https://lichess.org/CeNY4SjC#36",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00EgR",
        "FEN": "N2k3r/1b1n1Bpp/p7/1pb1P3/6P1/4p3/PPP4P/1K1R3R w - - 1 20",
        "Moves": "e5e6 b7h1 d1d7 d8c8 d7c7 c8b8",
        "Rating": 1832,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 2415,
        "Themes": "advantage long middlegame",
        "GameUrl": "https://lichess.org/PfKZb868#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Evs",
        "FEN": "5qk1/pQ3pp1/7p/b2N1b2/P3r3/5K2/7P/R4B2 b - - 1 24",
        "Moves": "g7g5 d5f6 g8h8 f6e4",
        "Rating": 1066,
        "RatingDeviation": 84,
        "Popularity": 91,
        "NbPlays": 951,
        "Themes": "advantage fork middlegame short",
        "GameUrl": "https://lichess.org/ZuufvD5S/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Fyu",
        "FEN": "r7/p1qbppbk/2p3p1/2pp4/4PP2/1P1P1N2/P1P3PP/3Q1RK1 b - - 2 16",
        "Moves": "d7g4 f3g5 h7g8 d1g4",
        "Rating": 977,
        "RatingDeviation": 245,
        "Popularity": -100,
        "NbPlays": 4,
        "Themes": "advantage discoveredAttack middlegame short",
        "GameUrl": "https://lichess.org/kjeZtnnv/black#31",
        "OpeningTags": "Bird_Opening Bird_Opening_Dutch_Variation"
    },
    {
        "PuzzleId": "00G7g",
        "FEN": "3r1rk1/p4pp1/b1p4p/8/BPPq4/P2P3P/2Q3P1/RNB4K b - - 2 27",
        "Moves": "d4a1 c1b2 a1b2 c2b2",
        "Rating": 1287,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 363,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/Gbq7pxMD/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GBV",
        "FEN": "3r1rk1/pp2n1pp/8/8/Nq6/1PB5/P3QPPP/4R1K1 b - - 1 25",
        "Moves": "b4d6 e2e7 d6e7 e1e7",
        "Rating": 1482,
        "RatingDeviation": 76,
        "Popularity": 86,
        "NbPlays": 301,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/MksLS6CR/black#49",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GBX",
        "FEN": "r6k/pp2n1pp/2nN4/4p1Br/1PB5/2P4b/P3Nb1P/R2R3K b - - 1 22",
        "Moves": "h5g5 d6f7 h8g8 f7g5",
        "Rating": 894,
        "RatingDeviation": 122,
        "Popularity": 100,
        "NbPlays": 34,
        "Themes": "advantage discoveredAttack fork middlegame short",
        "GameUrl": "https://lichess.org/1YLxwOt0/black#43",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GHw",
        "FEN": "r1bq1r2/1p4kp/4p1p1/1NpPp1P1/2P1P3/pPQ4B/P4n2/2KR3R b - - 1 21",
        "Moves": "f2h1 c3e5 g7g8 d5e6 d8e7 d1h1 e7g7 e5g7",
        "Rating": 2496,
        "RatingDeviation": 108,
        "Popularity": 90,
        "NbPlays": 306,
        "Themes": "advantage middlegame veryLong",
        "GameUrl": "https://lichess.org/VU9ATvfr/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GcF",
        "FEN": "6r1/1p1bRk2/p2q1n1r/3p4/3Q4/1P1B3P/P1P2PP1/4R1K1 b - - 4 27",
        "Moves": "d6e7 e1e7 f7e7 d4e3 e7f7 e3h6",
        "Rating": 1804,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 5280,
        "Themes": "advantage attraction exposedKing fork long middlegame",
        "GameUrl": "https://lichess.org/vZo2lFXq/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00GuG",
        "FEN": "2R5/7p/1K4k1/8/5p2/5n2/8/8 w - - 0 63",
        "Moves": "c8c6 g6f5 b6c5 h7h5",
        "Rating": 2382,
        "RatingDeviation": 104,
        "Popularity": 90,
        "NbPlays": 1166,
        "Themes": "advantage defensiveMove endgame master short",
        "GameUrl": "https://lichess.org/6xU6SaA2#124",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Gvr",
        "FEN": "8/1b3pp1/1k4Pp/4K2P/4PP2/8/8/8 b - - 0 46",
        "Moves": "f7f6 e5e6 b7e4 e6f7",
        "Rating": 1179,
        "RatingDeviation": 75,
        "Popularity": 89,
        "NbPlays": 2758,
        "Themes": "advantage bishopEndgame defensiveMove endgame master short",
        "GameUrl": "https://lichess.org/tHhRpYsL/black#91",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00H5n",
        "FEN": "8/5Rpk/3p3p/p1qPp3/P3n3/5N1P/1Q3PPK/2r5 b - - 0 35",
        "Moves": "e4f2 b2b7 c1h1 h2g3 f2e4 g3g4 e4f6 f7f6 c5b4 b7b4",
        "Rating": 2463,
        "RatingDeviation": 84,
        "Popularity": 87,
        "NbPlays": 238,
        "Themes": "advantage endgame pin quietMove veryLong",
        "GameUrl": "https://lichess.org/84oSZ8O3/black#69",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00HSV",
        "FEN": "r2q1kr1/ppp2p1p/2n5/8/3P4/P2BP1N1/1P1Q1PbP/R3K2R w KQ - 0 17",
        "Moves": "d3h7 g8g3 f2g3 g2h1",
        "Rating": 1853,
        "RatingDeviation": 77,
        "Popularity": 73,
        "NbPlays": 59,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/RldMoyAB#32",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Queens_Knight_Variation"
    },
    {
        "PuzzleId": "00HVU",
        "FEN": "r2qkb1r/ppp1pppp/8/3p3Q/3n1P2/3B3P/PPP2PP1/RN2K2R b KQkq - 1 9",
        "Moves": "g7g6 h5e5 d4f3 g2f3",
        "Rating": 1621,
        "RatingDeviation": 74,
        "Popularity": 91,
        "NbPlays": 1693,
        "Themes": "advantage fork middlegame short",
        "GameUrl": "https://lichess.org/SHbaicFX/black#17",
        "OpeningTags": "Indian_Defense Indian_Defense_Other_variations"
    },
    {
        "PuzzleId": "00IDw",
        "FEN": "4r3/pN3kpp/2N1b3/2R5/5b2/P7/1P3PPP/7K w - - 1 30",
        "Moves": "g2g3 e6h3 c5c1 f4c1",
        "Rating": 1875,
        "RatingDeviation": 75,
        "Popularity": 86,
        "NbPlays": 148,
        "Themes": "advantage endgame quietMove short",
        "GameUrl": "https://lichess.org/KmTVU8Fo#58",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00IYH",
        "FEN": "rnbq1rk1/ppp2pp1/3p1n1p/2b1p2N/2B1P3/3P4/PPP2PPP/RNBQ1RK1 b - - 2 7",
        "Moves": "c8g4 h5f6 d8f6 d1g4",
        "Rating": 1021,
        "RatingDeviation": 82,
        "Popularity": 93,
        "NbPlays": 2252,
        "Themes": "advantage kingsideAttack opening short",
        "GameUrl": "https://lichess.org/D9n0j4f5/black#13",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Alapin_Opening"
    },
    {
        "PuzzleId": "00IiM",
        "FEN": "r5k1/pp4p1/1n6/3pB3/3P2pb/2NQ1r2/PP6/2K3R1 w - - 2 24",
        "Moves": "d3f3 g4f3 g1g7 g8f8",
        "Rating": 1573,
        "RatingDeviation": 76,
        "Popularity": 92,
        "NbPlays": 2523,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/qzEITbaG#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00In2",
        "FEN": "8/b2r1p1k/5Qp1/1p5p/4p3/1P1q3P/5PP1/2B2RK1 b - - 13 38",
        "Moves": "d3b3 c1b2 b3b2 f6b2",
        "Rating": 1653,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 9477,
        "Themes": "advantage endgame quietMove short",
        "GameUrl": "https://lichess.org/Ut09PlkM/black#75",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00JYV",
        "FEN": "r2q1rk1/p1p1bppp/2pp1nb1/4p3/4P1PN/2NP3P/PPP2PK1/R1BQ1R2 b - - 4 11",
        "Moves": "f6e4 h4g6 e4c3 g6e7 d8e7 b2c3",
        "Rating": 1673,
        "RatingDeviation": 73,
        "Popularity": 96,
        "NbPlays": 11545,
        "Themes": "advantage kingsideAttack long opening",
        "GameUrl": "https://lichess.org/rJrzfvfs/black#21",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Steinitz_Defense"
    },
    {
        "PuzzleId": "00K8j",
        "FEN": "r2q2kr/p4pp1/4b2p/n1Qn4/5B2/4P3/PP3PPP/2KR1BNR w - - 1 14",
        "Moves": "f4c7 d8c7 c5c7 d5c7",
        "Rating": 1440,
        "RatingDeviation": 74,
        "Popularity": 87,
        "NbPlays": 202,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/AiNXhpcc#26",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Queens_Knight_Variation"
    },
    {
        "PuzzleId": "00KO5",
        "FEN": "2r2rk1/3p1ppp/p3p3/1p2q3/6P1/3Q4/PP5P/1K2RR2 b - - 0 22",
        "Moves": "e5h2 f1h1 h2c2 d3c2 c8c2 b1c2",
        "Rating": 1360,
        "RatingDeviation": 74,
        "Popularity": 87,
        "NbPlays": 130,
        "Themes": "advantage endgame long",
        "GameUrl": "https://lichess.org/jUnUTglG/black#43",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Kd8",
        "FEN": "3R4/3P4/8/5p2/5kPp/8/3r1KP1/8 w - - 1 64",
        "Moves": "f2g1 f4g3 g1f1 f5g4",
        "Rating": 2139,
        "RatingDeviation": 75,
        "Popularity": 79,
        "NbPlays": 266,
        "Themes": "advantage endgame rookEndgame short",
        "GameUrl": "https://lichess.org/loJK0sJF#126",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Knu",
        "FEN": "r2q1rk1/p3bpp1/2pp1nb1/4p1Q1/8/1B3N1P/PPP3P1/R1B2RK1 b - - 0 18",
        "Moves": "f6e4 g5g6 d8b6 g1h2",
        "Rating": 1864,
        "RatingDeviation": 77,
        "Popularity": 81,
        "NbPlays": 78,
        "Themes": "advantage defensiveMove opening pin short",
        "GameUrl": "https://lichess.org/ICZqsNVs/black#35",
        "OpeningTags": "Czech_Defense Czech_Defense_Other_variations"
    },
    {
        "PuzzleId": "00Kq4",
        "FEN": "r2qk3/5p1r/p1p1p3/1p1pP1p1/P1nP2Pn/2P2NB1/2P2P2/R1QR2K1 w q - 1 21",
        "Moves": "f3g5 d8g5 c1g5 h4f3 g1g2 f3g5",
        "Rating": 1354,
        "RatingDeviation": 75,
        "Popularity": 81,
        "NbPlays": 540,
        "Themes": "advantage attraction fork long middlegame sacrifice",
        "GameUrl": "https://lichess.org/o4K7aQsT#40",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LBF",
        "FEN": "3r2k1/1b2qpb1/pp4p1/3rp3/3R2P1/2P2NBP/PP2Q2K/3R4 b - - 0 33",
        "Moves": "e7d7 d4d5 b7d5 c3c4",
        "Rating": 2188,
        "RatingDeviation": 79,
        "Popularity": 82,
        "NbPlays": 59,
        "Themes": "advantage master middlegame short",
        "GameUrl": "https://lichess.org/HG0KKbWc/black#65",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LG5",
        "FEN": "6k1/5r1p/4b1pQ/5q2/3B3P/2P5/6P1/4R1K1 w - - 7 36",
        "Moves": "e1e2 f5f1 g1h2 f1e2",
        "Rating": 1135,
        "RatingDeviation": 76,
        "Popularity": 71,
        "NbPlays": 152,
        "Themes": "advantage endgame fork short",
        "GameUrl": "https://lichess.org/H1PJMeLA#70",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LII",
        "FEN": "2k4r/pp6/3p4/2pBb3/4P2B/2P2bp1/PP1R4/R5K1 w - - 1 32",
        "Moves": "d2g2 h8h4 a1f1 f3g2",
        "Rating": 1634,
        "RatingDeviation": 78,
        "Popularity": 85,
        "NbPlays": 58,
        "Themes": "advantage hangingPiece middlegame short",
        "GameUrl": "https://lichess.org/0PFmmeVw#62",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LO6",
        "FEN": "2r3k1/3q1pp1/1rp5/2Rn2Np/1p1N3n/1Q2P3/5PP1/2R3K1 w - - 0 33",
        "Moves": "c5d5 c6d5 c1c8 d7c8",
        "Rating": 1615,
        "RatingDeviation": 75,
        "Popularity": 88,
        "NbPlays": 73,
        "Themes": "advantage middlegame short",
        "GameUrl": "https://lichess.org/X0I5NJuv#64",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LSv",
        "FEN": "3r3k/1p4pp/2p3q1/8/3Q4/8/PP4rP/R4R1K b - - 1 28",
        "Moves": "g2g1 d4g1 g6e4 g1g2",
        "Rating": 1703,
        "RatingDeviation": 74,
        "Popularity": 91,
        "NbPlays": 624,
        "Themes": "advantage endgame short",
        "GameUrl": "https://lichess.org/EfV2OOTd/black#55",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LXD",
        "FEN": "8/p7/1p2k1pp/5p2/3P1P2/4K3/PP5P/8 w - - 2 37",
        "Moves": "a2a4 g6g5 f4g5 h6g5",
        "Rating": 2357,
        "RatingDeviation": 82,
        "Popularity": 26,
        "NbPlays": 49,
        "Themes": "advantage endgame pawnEndgame short",
        "GameUrl": "https://lichess.org/aSmBXG8T#72",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00LZf",
        "FEN": "r1b1kb1r/pppp1ppp/2n1p3/3nN3/3P2q1/4B3/PPP1BPPP/RN1Q1RK1 b kq - 9 8",
        "Moves": "d5e3 f2e3 g4g5 e5f7 g5e3 g1h1",
        "Rating": 2184,
        "RatingDeviation": 90,
        "Popularity": 25,
        "NbPlays": 33,
        "Themes": "advantage attackingF2F7 fork long opening",
        "GameUrl": "https://lichess.org/sVgQxr8Q/black#15",
        "OpeningTags": "French_Defense French_Defense_Normal_Variation"
    },
    {
        "PuzzleId": "00008",
        "FEN": "r6k/pp2r2p/4Rp1Q/3p4/8/1N1P2R1/PqP2bPP/7K b - - 0 24",
        "Moves": "f2g3 e6e7 b2b1 b3c1 b1c1 h6c1",
        "Rating": 1913,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 6230,
        "Themes": "crushing hangingPiece long middlegame",
        "GameUrl": "https://lichess.org/787zsVup/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "000mr",
        "FEN": "5r1k/5rp1/p7/1b2B2p/1P1P1Pq1/2R1Q3/P3p1P1/2R3K1 w - - 0 41",
        "Moves": "e3g3 f7f4 e5f4 f8f4",
        "Rating": 1941,
        "RatingDeviation": 85,
        "Popularity": 62,
        "NbPlays": 93,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/8sVpuwso#80",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001XA",
        "FEN": "1qr2rk1/pb2bppp/8/8/2p1N3/P1Bn2P1/2Q2PBP/1R3RK1 b - - 3 23",
        "Moves": "b8c7 b1b7 c7b7 e4f6 e7f6 g2b7",
        "Rating": 1657,
        "RatingDeviation": 75,
        "Popularity": 91,
        "NbPlays": 1041,
        "Themes": "crushing discoveredAttack long master middlegame sacrifice",
        "GameUrl": "https://lichess.org/KZRiN695/black#45",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001h8",
        "FEN": "2r3k1/2r4p/4p1p1/1p1q1pP1/p1bP1P1Q/P6R/5B2/2R3K1 b - - 5 34",
        "Moves": "c4e2 h4h7 c7h7 c1c8 g8g7 c8c7",
        "Rating": 1827,
        "RatingDeviation": 76,
        "Popularity": 93,
        "NbPlays": 446,
        "Themes": "crushing deflection kingsideAttack long middlegame sacrifice",
        "GameUrl": "https://lichess.org/IxCahP6X/black#67",
        "OpeningTags": null
    },
    {
        "PuzzleId": "001xO",
        "FEN": "k1r1b3/p1r1nppp/1p1qpn2/2Np4/1P1P4/PQRBPN2/5PPP/2R3K1 w - - 0 19",
        "Moves": "d3a6 b6c5 a6c8 c5c4",
        "Rating": 1833,
        "RatingDeviation": 74,
        "Popularity": 91,
        "NbPlays": 1063,
        "Themes": "crushing master masterVsMaster middlegame sacrifice short",
        "GameUrl": "https://lichess.org/fNCePFgY#36",
        "OpeningTags": "Slav_Defense Slav_Defense_Other_variations"
    },
    {
        "PuzzleId": "002KJ",
        "FEN": "r3kb1r/ppq2ppp/4pn2/2Ppn3/1P4bP/2P2N2/P3BPP1/RNBQ1RK1 b kq - 2 10",
        "Moves": "f8e7 f3e5 c7e5 e2g4",
        "Rating": 1515,
        "RatingDeviation": 75,
        "Popularity": 94,
        "NbPlays": 1098,
        "Themes": "crushing discoveredAttack middlegame short",
        "GameUrl": "https://lichess.org/2NpTzh7O/black#19",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Advance_Variation"
    },
    {
        "PuzzleId": "002O7",
        "FEN": "r3qrk1/2p2pp1/p2bpn1p/2ppNb2/3P1P2/1PP1P1B1/P2N2PP/R2Q1RK1 b - - 0 14",
        "Moves": "f5g4 e5g4 f6g4 d1g4",
        "Rating": 969,
        "RatingDeviation": 92,
        "Popularity": 91,
        "NbPlays": 344,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/dFEPPiEc/black#27",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Accelerated_London_System"
    },
    {
        "PuzzleId": "002Ua",
        "FEN": "r4rk1/pp3ppp/3p1q2/P1P1p3/2B5/2B2n2/2P2P1P/R2Q1RK1 w - - 0 16",
        "Moves": "g1h1 f6f4 d1f3 f4f3",
        "Rating": 1765,
        "RatingDeviation": 74,
        "Popularity": 95,
        "NbPlays": 6344,
        "Themes": "crushing kingsideAttack middlegame short",
        "GameUrl": "https://lichess.org/06i3eMVp#30",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Lowenthal_Variation"
    },
    {
        "PuzzleId": "002rd",
        "FEN": "r6k/q1pb1p1p/1b3Pr1/p1ppP2Q/3P2p1/4B3/PP2NRPP/3R2K1 b - - 1 25",
        "Moves": "d7e6 e2f4 c5d4 f4g6 f7g6 h5h6",
        "Rating": 1812,
        "RatingDeviation": 74,
        "Popularity": 78,
        "NbPlays": 118,
        "Themes": "crushing kingsideAttack long middlegame pin",
        "GameUrl": "https://lichess.org/NcD6lul8/black#49",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003eP",
        "FEN": "8/r1b1q2k/2p3p1/2Pp4/1P2p1n1/2B1P3/NQ6/2K4R b - - 1 36",
        "Moves": "h7g8 h1h8 g8f7 h8h7 f7e8 h7e7",
        "Rating": 1157,
        "RatingDeviation": 79,
        "Popularity": 88,
        "NbPlays": 1750,
        "Themes": "crushing exposedKing long middlegame skewer",
        "GameUrl": "https://lichess.org/n9vCFmKh/black#71",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003jH",
        "FEN": "rn3rk1/p5pp/3N4/4np1q/5Q2/1P3K2/PB1P2P1/2R4R w - - 0 25",
        "Moves": "f3f2 e5d3 f2e3 d3f4 h1h5 f4h5",
        "Rating": 1128,
        "RatingDeviation": 78,
        "Popularity": 89,
        "NbPlays": 290,
        "Themes": "crushing fork long middlegame",
        "GameUrl": "https://lichess.org/3CQGofXT#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003jb",
        "FEN": "r3kb1r/p4ppp/b1p1p3/3q4/3Q4/4BN2/PPP2PPP/R3K2R b KQkq - 0 11",
        "Moves": "c6c5 d4a4 a6b5 a4b5",
        "Rating": 977,
        "RatingDeviation": 75,
        "Popularity": 95,
        "NbPlays": 2509,
        "Themes": "crushing fork middlegame short",
        "GameUrl": "https://lichess.org/960EzUS0/black#21",
        "OpeningTags": "French_Defense French_Defense_Classical_Variation"
    },
    {
        "PuzzleId": "003md",
        "FEN": "r1b1k2N/ppp3pp/2n5/2bp4/7q/1B4n1/PPPP1P1P/RNBQ1RK1 w q - 0 10",
        "Moves": "f1e1 g3e4 e1e4 d5e4 d1h5 h4h5 b3f7 h5f7",
        "Rating": 2117,
        "RatingDeviation": 79,
        "Popularity": 84,
        "NbPlays": 204,
        "Themes": "crushing defensiveMove middlegame veryLong",
        "GameUrl": "https://lichess.org/ALtR2fxT#18",
        "OpeningTags": "Russian_Game Russian_Game_Italian_Variation"
    },
    {
        "PuzzleId": "003nQ",
        "FEN": "6rk/pp6/2n5/3ppn1p/3p4/2P2P1q/PP3QNB/R4R1K w - - 2 29",
        "Moves": "f1g1 f5g3 f2g3 g8g3",
        "Rating": 1280,
        "RatingDeviation": 89,
        "Popularity": 67,
        "NbPlays": 27,
        "Themes": "crushing kingsideAttack master middlegame pin short",
        "GameUrl": "https://lichess.org/p85fiZcl#56",
        "OpeningTags": null
    },
    {
        "PuzzleId": "003r5",
        "FEN": "r2qr1k1/ppp2ppp/4b3/3P4/1nP2Q2/2N2N1P/PP3KP1/R4R2 w - - 1 15",
        "Moves": "d5e6 b4d3 f2g1 d3f4",
        "Rating": 1107,
        "RatingDeviation": 77,
        "Popularity": 87,
        "NbPlays": 855,
        "Themes": "crushing fork middlegame short",
        "GameUrl": "https://lichess.org/JPN97v7j#28",
        "OpeningTags": "Kings_Gambit_Accepted Kings_Gambit_Accepted_Abbazia_Defense"
    },
    {
        "PuzzleId": "004Op",
        "FEN": "2kr2r1/1bp4n/1pq1p2p/p1P5/1P3B2/P6P/5RP1/RB2Q1K1 w - - 3 26",
        "Moves": "e1f1 d8d1 f1d1 g8g2 g1f1 g2g1 f1e2 g1d1",
        "Rating": 2138,
        "RatingDeviation": 78,
        "Popularity": 91,
        "NbPlays": 1259,
        "Themes": "crushing deflection kingsideAttack middlegame pin sacrifice skewer veryLong",
        "GameUrl": "https://lichess.org/tneg9Bzk#50",
        "OpeningTags": null
    },
    {
        "PuzzleId": "004kB",
        "FEN": "4rr1k/pQpn2pp/3p1q2/8/8/2P5/PP3PPP/RN3RK1 w - - 1 16",
        "Moves": "b7c7 f6f2 f1f2 e8e1 f2f1 e1f1",
        "Rating": 1226,
        "RatingDeviation": 74,
        "Popularity": 92,
        "NbPlays": 159,
        "Themes": "kingsideAttack long mate mateIn3 middlegame sacrifice",
        "GameUrl": "https://lichess.org/Cl9T6bjt#30",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Steinitz_Defense"
    },
    {
        "PuzzleId": "004nd",
        "FEN": "3q2k1/2r5/pp3p1Q/2b1n3/P3N3/2P5/1P4PP/R6K b - - 0 24",
        "Moves": "c7d7 e4f6 d8f6 h6f6",
        "Rating": 898,
        "RatingDeviation": 75,
        "Popularity": 83,
        "NbPlays": 204,
        "Themes": "crushing fork middlegame short",
        "GameUrl": "https://lichess.org/IajkZZBp/black#47",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005HF",
        "FEN": "3r1rk1/1pR3pp/p2bp3/1q2Np2/3P4/1P5Q/5PPP/4R1K1 w - - 2 27",
        "Moves": "c7g7 g8g7 h3g3 g7h8",
        "Rating": 1380,
        "RatingDeviation": 78,
        "Popularity": 72,
        "NbPlays": 52,
        "Themes": "crushing defensiveMove hangingPiece middlegame short",
        "GameUrl": "https://lichess.org/IqVPsfjB#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005YX",
        "FEN": "2rr4/2N2pk1/p1Q1b1pp/1p4q1/3pP3/1B1P4/PPP3PP/6RK w - - 7 25",
        "Moves": "c7e6 f7e6 c6b7 g7h8",
        "Rating": 1440,
        "RatingDeviation": 309,
        "Popularity": 100,
        "NbPlays": 12,
        "Themes": "defensiveMove equality middlegame short",
        "GameUrl": "https://lichess.org/zbi5w5Qy#48",
        "OpeningTags": null
    },
    {
        "PuzzleId": "005wy",
        "FEN": "1r6/pp2kpp1/2n1p1n1/3p2PQ/5P2/2PqP3/PP1N4/2KR3R w - - 3 27",
        "Moves": "h5h7 c6b4 c3b4 b8c8 d2c4 c8c4",
        "Rating": 2062,
        "RatingDeviation": 74,
        "Popularity": 94,
        "NbPlays": 2988,
        "Themes": "long mate mateIn3 middlegame queensideAttack sacrifice",
        "GameUrl": "https://lichess.org/mBQMheB4#52",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0068B",
        "FEN": "r1q3k1/4bppp/pp2pn2/4B3/8/2N2Q2/PPPR1PPP/6K1 b - - 0 18",
        "Moves": "f6d7 d2d7 c8d7 f3a8",
        "Rating": 1519,
        "RatingDeviation": 74,
        "Popularity": 92,
        "NbPlays": 5784,
        "Themes": "crushing deflection middlegame short",
        "GameUrl": "https://lichess.org/LNdzAgWP/black#35",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Katalimov_Variation"
    },
    {
        "PuzzleId": "006RM",
        "FEN": "1k1r3r/2q5/pp1n2p1/8/1Q6/3R2P1/PPP2P1P/3R2K1 b - - 4 29",
        "Moves": "c7c5 b4c5 b6c5 d3d6 d8d6 d1d6",
        "Rating": 1382,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 1078,
        "Themes": "crushing long middlegame",
        "GameUrl": "https://lichess.org/ceS0QvtT/black#57",
        "OpeningTags": null
    },
    {
        "PuzzleId": "0078T",
        "FEN": "rk5r/1b3R2/pp2p2q/4P2p/B2p3B/4R2P/PP4P1/5Q1K b - - 0 27",
        "Moves": "d4e3 f7b7 b8b7 f1f7 b7b8 h4e7",
        "Rating": 2267,
        "RatingDeviation": 79,
        "Popularity": 81,
        "NbPlays": 81,
        "Themes": "attraction crushing defensiveMove exposedKing long middlegame queensideAttack sacrifice",
        "GameUrl": "https://lichess.org/mXf4gFYU/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "007AS",
        "FEN": "r3kb1r/3nnpp1/4p1bp/1NppP3/3P4/6N1/P2BBPPP/R3K2R b KQkq - 0 17",
        "Moves": "a8b8 b5d6 e8d8 d2a5",
        "Rating": 1627,
        "RatingDeviation": 83,
        "Popularity": 87,
        "NbPlays": 30,
        "Themes": "crushing master middlegame short",
        "GameUrl": "https://lichess.org/Nfuw1Dug/black#33",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Advance_Variation"
    },
    {
        "PuzzleId": "008LT",
        "FEN": "r4rk1/6p1/b3p1nN/p1pp4/1p3P1q/3P1Q1B/PPP2PK1/R6R b - - 0 26",
        "Moves": "g8h8 h6f7 f8f7 h3e6",
        "Rating": 2460,
        "RatingDeviation": 80,
        "Popularity": 90,
        "NbPlays": 1125,
        "Themes": "crushing kingsideAttack middlegame pin sacrifice short",
        "GameUrl": "https://lichess.org/vnxisKeU/black#51",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008lc",
        "FEN": "7k/pb1qn2n/1p2R2Q/2p2p2/2Pp4/3B4/PP3PrP/4RK2 b - - 1 27",
        "Moves": "g2g7 h6g7 h8g7 e6e7 d7e7 e1e7",
        "Rating": 1880,
        "RatingDeviation": 75,
        "Popularity": 92,
        "NbPlays": 1808,
        "Themes": "attraction crushing exposedKing fork long middlegame",
        "GameUrl": "https://lichess.org/UdZXrVA5/black#53",
        "OpeningTags": null
    },
    {
        "PuzzleId": "008nF",
        "FEN": "2rq1rk1/7p/1n4pb/1R2p3/pPpP1P2/P1B5/3NQ1PP/2R3K1 w - - 0 31",
        "Moves": "e2e5 f8e8 e5e8 d8e8",
        "Rating": 2373,
        "RatingDeviation": 88,
        "Popularity": 89,
        "NbPlays": 604,
        "Themes": "crushing master middlegame short trappedPiece",
        "GameUrl": "https://lichess.org/tYO5rrIU#60",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009Os",
        "FEN": "r2b2k1/1p3q1p/p2p4/3P2p1/2P1PRQr/8/P2B3P/2R4K w - - 1 29",
        "Moves": "g4g3 h4f4 d2f4 f7f4 g3f4 g5f4",
        "Rating": 1392,
        "RatingDeviation": 89,
        "Popularity": 76,
        "NbPlays": 36,
        "Themes": "crushing long middlegame",
        "GameUrl": "https://lichess.org/AdjEnXlm#56",
        "OpeningTags": null
    },
    {
        "PuzzleId": "009Wc",
        "FEN": "1r3rk1/1pq2pbp/p1p1pnp1/2N1N3/3P4/1QP5/PP3PPP/3RR1K1 w - - 2 19",
        "Moves": "e5d7 f6d7 c5d7 c7d7",
        "Rating": 974,
        "RatingDeviation": 79,
        "Popularity": 95,
        "NbPlays": 1377,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/WnthPrdl#36",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Classical_Variation"
    },
    {
        "PuzzleId": "00A1H",
        "FEN": "2r3k1/4brp1/2p3b1/2Pp1q1p/3B3P/2P2N2/PP3P1K/R2Q2R1 w - - 1 31",
        "Moves": "f3g5 f5f4 h2g2 e7g5",
        "Rating": 2041,
        "RatingDeviation": 84,
        "Popularity": 82,
        "NbPlays": 202,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/GeoPB5fa#60",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Aas",
        "FEN": "3r1rk1/1p2q1pp/5p2/8/1P1n4/6Q1/PPbB1PPP/R2B1RK1 w - - 9 20",
        "Moves": "d1c2 d4e2 g1h1 e2g3 f2g3 d8d2",
        "Rating": 1147,
        "RatingDeviation": 75,
        "Popularity": 98,
        "NbPlays": 6666,
        "Themes": "crushing fork long middlegame",
        "GameUrl": "https://lichess.org/wYjuq3zz#38",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Ahb",
        "FEN": "1k4nr/pp1r1ppp/4p3/1Nb2q2/2Pp4/6P1/PP3P1P/R1BQR1K1 b - - 2 14",
        "Moves": "g8h6 c1f4 f5f4 g3f4",
        "Rating": 1138,
        "RatingDeviation": 76,
        "Popularity": 83,
        "NbPlays": 228,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/Cyj8Qkox/black#27",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Franco-Sicilian_Variation"
    },
    {
        "PuzzleId": "00Aok",
        "FEN": "5rk1/Q2B1p1p/4p1p1/3p4/3N2b1/2q5/Pr3RPP/5RK1 w - - 0 23",
        "Moves": "f2f7 c3e3 g1h1 f8f7 a7a8 g8g7 f1f7 g7f7 a8e8 f7f6",
        "Rating": 2236,
        "RatingDeviation": 95,
        "Popularity": 51,
        "NbPlays": 26,
        "Themes": "crushing intermezzo middlegame veryLong",
        "GameUrl": "https://lichess.org/kVjMAqKr#44",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Aq4",
        "FEN": "2k1r3/pppn1pp1/3b2b1/3p2Pp/2B2P2/3P3P/PPPR4/2K3NR w - - 0 18",
        "Moves": "c4d5 e8e1 d2d1 d6f4 c1b1 e1d1",
        "Rating": 1577,
        "RatingDeviation": 113,
        "Popularity": 47,
        "NbPlays": 82,
        "Themes": "backRankMate deflection long mate mateIn3 middlegame",
        "GameUrl": "https://lichess.org/VIBqOZyc#34",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Main_Line"
    },
    {
        "PuzzleId": "00B7G",
        "FEN": "1rb2r1k/4q2p/p2p4/3B1p2/1pPb4/1P2NQ2/P5PP/2R2RK1 w - - 1 24",
        "Moves": "g1h1 e7e3 f3e3 d4e3",
        "Rating": 1688,
        "RatingDeviation": 74,
        "Popularity": 86,
        "NbPlays": 144,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/jBgjHSYd#46",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00Bex",
        "FEN": "1rb1qrk1/6bp/2np4/2pNpp2/2P5/3P1B2/1B3PPP/1R1QR1K1 b - - 0 22",
        "Moves": "c8e6 d5c7 e8f7 c7e6",
        "Rating": 1657,
        "RatingDeviation": 121,
        "Popularity": 33,
        "NbPlays": 17,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/qNuFxL0D/black#43",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00BrZ",
        "FEN": "r6r/pp2kb2/3p1p1Q/1N1Pp3/3bP3/P2B2P1/1P4PP/7K w - - 6 28",
        "Moves": "h6d2 h8h2 h1h2 a8h8 d2h6 h8h6",
        "Rating": 1412,
        "RatingDeviation": 75,
        "Popularity": 84,
        "NbPlays": 435,
        "Themes": "attraction kingsideAttack long mate mateIn3 middlegame sacrifice",
        "GameUrl": "https://lichess.org/ANKrgoJi#54",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00CiZ",
        "FEN": "5r1k/6b1/3p3p/1P1q2pQ/r5P1/3p1N1P/3R2P1/4R2K w - - 2 34",
        "Moves": "e1d1 f8f3 g2f3 d5f3",
        "Rating": 1362,
        "RatingDeviation": 78,
        "Popularity": 77,
        "NbPlays": 133,
        "Themes": "crushing middlegame short",
        "GameUrl": "https://lichess.org/PJQUqCX1#66",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00D77",
        "FEN": "5rk1/bpp3pp/p1npb3/4p3/1P2Nr1q/P1PP3P/1B1QBPR1/2K3R1 b - - 2 21",
        "Moves": "h4h3 g2g7 g8h8 e4g5",
        "Rating": 1909,
        "RatingDeviation": 75,
        "Popularity": 92,
        "NbPlays": 1733,
        "Themes": "crushing kingsideAttack middlegame short",
        "GameUrl": "https://lichess.org/PgppfwbE/black#41",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00D7x",
        "FEN": "rnq2r2/pp3pbk/3p1n2/2pPpPQ1/2P1P3/2N2NP1/PP4KP/R4R2 b - - 2 18",
        "Moves": "f8g8 g5h4 g7h6 h4f6",
        "Rating": 1554,
        "RatingDeviation": 75,
        "Popularity": 95,
        "NbPlays": 19560,
        "Themes": "crushing deflection middlegame short",
        "GameUrl": "https://lichess.org/RKX1Co2s/black#35",
        "OpeningTags": "Benoni_Defense Benoni_Defense_Old_Benoni"
    },
    {
        "PuzzleId": "00DTg",
        "FEN": "r2qk2r/1pp2ppp/p1pb1n2/4P3/3Q4/2N2b2/PPP2PPP/R1B2RK1 w kq - 0 10",
        "Moves": "e5f6 d6h2 g1h2 d8d4",
        "Rating": 1095,
        "RatingDeviation": 82,
        "Popularity": 94,
        "NbPlays": 2462,
        "Themes": "crushing discoveredAttack kingsideAttack middlegame short",
        "GameUrl": "https://lichess.org/EqbT8Dsc#18",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Exchange_Variation"
    },
    {
        "PuzzleId": "0092V",
        "FEN": "r2qk1nr/ppp3pp/2n5/1B1pp3/1b1P4/5Q1P/PP1B1PP1/RN2K2R b KQkq - 3 11",
        "Moves": "e5e4 b5c6 b7c6 f3h5 g7g6 h5e5",
        "Rating": 2526,
        "RatingDeviation": 82,
        "Popularity": 93,
        "NbPlays": 1026,
        "Themes": "crushing exposedKing long opening",
        "GameUrl": "https://lichess.org/bW5LiCa5/black#21",
        "OpeningTags": "Ponziani_Opening Ponziani_Opening_Other_variations"
    },
    {
        "PuzzleId": "009FS",
        "FEN": "r2qr1k1/p5bp/1pp1b1p1/8/2QN1p2/2P1n2P/PP3PP1/R1B1RNK1 w - - 1 18",
        "Moves": "d4e6 e3c4 e6d8 e8e1",
        "Rating": 1739,
        "RatingDeviation": 75,
        "Popularity": 76,
        "NbPlays": 123,
        "Themes": "crushing discoveredAttack opening short",
        "GameUrl": "https://lichess.org/MOdm5bE7#34",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Closed"
    },
    {
        "PuzzleId": "009XT",
        "FEN": "rn1qk2r/pp3ppp/3bp1b1/3p4/3Pn2N/3BB3/PPP2PPP/RN1Q1RK1 w kq - 4 10",
        "Moves": "h4g6 d6h2 g1h1 h7g6",
        "Rating": 1964,
        "RatingDeviation": 73,
        "Popularity": 93,
        "NbPlays": 12505,
        "Themes": "crushing intermezzo opening short",
        "GameUrl": "https://lichess.org/bf23N8Ng#18",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Exchange_Variation"
    },
    {
        "PuzzleId": "00AVR",
        "FEN": "br1qkb1r/p1pp1ppp/4Pn2/6B1/3Qn3/5NP1/P3PPBP/RN1R2K1 b k - 0 15",
        "Moves": "d7e6 d4a4 d8d7 d1d7",
        "Rating": 1744,
        "RatingDeviation": 77,
        "Popularity": 77,
        "NbPlays": 86,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/KxeQFmHl/black#29",
        "OpeningTags": "Zukertort_Opening Zukertort_Opening_Black_Mustang_Defense"
    },
    {
        "PuzzleId": "00C3O",
        "FEN": "r2qkbnr/pp4pp/2p2p2/4n2b/2B1P3/2N2N2/PPP3PP/R1BQ1RK1 w kq - 0 10",
        "Moves": "d1e2 h5f3 g2f3 d8d4",
        "Rating": 2006,
        "RatingDeviation": 78,
        "Popularity": 92,
        "NbPlays": 1310,
        "Themes": "crushing kingsideAttack opening short",
        "GameUrl": "https://lichess.org/F4Vo1eZG#18",
        "OpeningTags": "Kings_Gambit Kings_Gambit_Other_variations"
    },
    {
        "PuzzleId": "00EbJ",
        "FEN": "r2q1rk1/ppp2ppp/2nbb3/8/6n1/2NPBN2/PPP1BPPP/R2QK2R w KQ - 5 9",
        "Moves": "f3g5 g4e3 f2e3 d8g5",
        "Rating": 1203,
        "RatingDeviation": 92,
        "Popularity": 53,
        "NbPlays": 73,
        "Themes": "capturingDefender crushing opening short",
        "GameUrl": "https://lichess.org/wlZv7BWx#16",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Modern_Variation"
    },
    {
        "PuzzleId": "00Htd",
        "FEN": "rnbqk2r/1p3ppp/p4b2/2Pp4/8/2N2N2/PP2PPPP/R2QKB1R w KQkq - 0 9",
        "Moves": "d1d5 f6c3 b2c3 d8d5",
        "Rating": 987,
        "RatingDeviation": 85,
        "Popularity": 93,
        "NbPlays": 1009,
        "Themes": "crushing intermezzo opening short",
        "GameUrl": "https://lichess.org/ZWQwqa9S#16",
        "OpeningTags": "Tarrasch_Defense Tarrasch_Defense_Two_Knights_Variation"
    },
    {
        "PuzzleId": "00KUa",
        "FEN": "r1bk1bnr/pppp1Bpp/8/3Nq3/3nP3/3P4/PPP2PPP/R1BQK2R b KQ - 0 8",
        "Moves": "g8f6 c1f4 e5f4 d5f4",
        "Rating": 1555,
        "RatingDeviation": 161,
        "Popularity": -100,
        "NbPlays": 11,
        "Themes": "crushing opening short trappedPiece",
        "GameUrl": "https://lichess.org/QBzgVaj1/black#15",
        "OpeningTags": "Italian_Game Italian_Game_Blackburne-Kostic_Gambit"
    },
    {
        "PuzzleId": "00LZl",
        "FEN": "r2qkb1r/ppp2ppp/2n5/3pPb2/3n1B2/2NB1N2/PP3PPP/R2QK2R b KQkq - 3 9",
        "Moves": "f8b4 f3d4 c6d4 d1a4 d4c6 d3f5",
        "Rating": 2059,
        "RatingDeviation": 76,
        "Popularity": 93,
        "NbPlays": 5096,
        "Themes": "advantage deflection fork long opening",
        "GameUrl": "https://lichess.org/jBb2kj01/black#17",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Macleod_Attack"
    },
    {
        "PuzzleId": "00M7w",
        "FEN": "r1b1k2r/ppp2ppp/2n5/2bBp3/2Pq4/3P1QP1/P2B1P1P/1R2K1NR b Kkq - 2 12",
        "Moves": "f7f6 g1e2 d4f2 f3f2 c5f2 e1f2",
        "Rating": 2217,
        "RatingDeviation": 81,
        "Popularity": 91,
        "NbPlays": 1765,
        "Themes": "crushing long opening",
        "GameUrl": "https://lichess.org/rhyiYyX3/black#23",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Main_Line"
    },
    {
        "PuzzleId": "00Nf5",
        "FEN": "r1bq1rk1/pp2bppp/2pp1n2/8/5P2/5N2/PBPPB1PP/RN1Q1RK1 w - - 5 11",
        "Moves": "b1c3 d8b6 g1h1 b6b2 a1b1 b2a3",
        "Rating": 1581,
        "RatingDeviation": 76,
        "Popularity": 94,
        "NbPlays": 8016,
        "Themes": "advantage fork long opening",
        "GameUrl": "https://lichess.org/JkE5qS7u#20",
        "OpeningTags": "Polish_Opening Polish_Opening_Other_variations"
    },
    {
        "PuzzleId": "00Qnn",
        "FEN": "r1bqkb1r/ppp1n1p1/7p/3Pp1N1/2P5/8/PP3PPP/RNBQK2R w KQkq - 0 11",
        "Moves": "d1h5 g7g6 h5e2 h6g5",
        "Rating": 1476,
        "RatingDeviation": 222,
        "Popularity": 100,
        "NbPlays": 10,
        "Themes": "defensiveMove equality opening short",
        "GameUrl": "https://lichess.org/bvZx0hh4#20",
        "OpeningTags": null
    },
    {
        "PuzzleId": "00R0l",
        "FEN": "rnbqkb1r/pp3p1p/6pP/P1ppp3/6n1/3P1P2/1PP1P1P1/RNBQKBNR b KQkq - 0 7",
        "Moves": "g4h6 c1h6 f8h6 h1h6",
        "Rating": 1415,
        "RatingDeviation": 81,
        "Popularity": 87,
        "NbPlays": 1445,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/y06s0jL8/black#13",
        "OpeningTags": "Ware_Opening Ware_Opening_Other_variations"
    },
    {
        "PuzzleId": "00Rue",
        "FEN": "r2qkb1r/pp1nppp1/2p2n1p/3p1b2/3P4/BP2PN2/P1P2PPP/RN1QKB1R w KQkq - 2 7",
        "Moves": "c2c4 f5b1 a1b1 d8a5 b3b4 a5a3",
        "Rating": 1966,
        "RatingDeviation": 73,
        "Popularity": 95,
        "NbPlays": 13819,
        "Themes": "advantage fork long opening",
        "GameUrl": "https://lichess.org/tgFzBrLu#12",
        "OpeningTags": "Nimzo-Larsen_Attack Nimzo-Larsen_Attack_Classical_Variation"
    },
    {
        "PuzzleId": "00SyL",
        "FEN": "1rb2rk1/4bppp/p1n1p3/1p1qP3/7N/P5P1/1PQ2PBP/R1B2RK1 b - - 1 15",
        "Moves": "d5c5 c2c5 e7c5 g2c6",
        "Rating": 1249,
        "RatingDeviation": 77,
        "Popularity": 91,
        "NbPlays": 5789,
        "Themes": "capturingDefender crushing opening short",
        "GameUrl": "https://lichess.org/f988q4eE/black#29",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Old_Sicilian"
    },
    {
        "PuzzleId": "00TxB",
        "FEN": "r2qkb1r/pp3ppp/2pp1nn1/8/4PB2/2N2B2/PPP2PPP/R2Q1RK1 w kq - 2 10",
        "Moves": "f1e1 g6f4",
        "Rating": 877,
        "RatingDeviation": 84,
        "Popularity": 95,
        "NbPlays": 2229,
        "Themes": "advantage hangingPiece oneMove opening",
        "GameUrl": "https://lichess.org/J5i5UOW9#18",
        "OpeningTags": "Philidor_Defense Philidor_Defense_Other_variations"
    },
    {
        "PuzzleId": "00WUu",
        "FEN": "r3k1nr/pp3ppp/1q2b3/8/1n1p4/6P1/PB1QPPBP/R3K1NR w KQkq - 0 13",
        "Moves": "b2d4 b6d4 d2d4 b4c2 e1f1 c2d4",
        "Rating": 1544,
        "RatingDeviation": 77,
        "Popularity": 88,
        "NbPlays": 1089,
        "Themes": "attraction crushing fork long opening sacrifice",
        "GameUrl": "https://lichess.org/lxJ3tlcz#24",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Tarrasch_Defense"
    },
    {
        "PuzzleId": "00WmI",
        "FEN": "1nbqkbnr/r4ppp/p7/1ppB4/8/2NP4/PPP2PPP/R1BQK1NR w KQk - 1 8",
        "Moves": "c1e3 b5b4",
        "Rating": 1313,
        "RatingDeviation": 76,
        "Popularity": 72,
        "NbPlays": 142,
        "Themes": "advantage oneMove opening",
        "GameUrl": "https://lichess.org/Xj2zo6H9#14",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Bowdler_Attack"
    },
    {
        "PuzzleId": "00WsE",
        "FEN": "r2qkb1r/1Q1npppp/p2pb3/8/4P3/5N2/PPP2PPP/R1B1KB1R w KQkq - 1 9",
        "Moves": "f1a6 d8a5 b2b4 a5a6 b7a6 a8a6",
        "Rating": 1444,
        "RatingDeviation": 83,
        "Popularity": 80,
        "NbPlays": 48,
        "Themes": "advantage long opening",
        "GameUrl": "https://lichess.org/rbi2PN9x#16",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Modern_Variations"
    },
    {
        "PuzzleId": "00Y5Q",
        "FEN": "rnbq1rk1/pp2b2p/4p2p/3p1p1Q/2pP4/P1N5/1PP1PPPP/2KR1BNR w - - 0 11",
        "Moves": "h5h6 e7g5 h6g5 d8g5",
        "Rating": 870,
        "RatingDeviation": 91,
        "Popularity": 95,
        "NbPlays": 883,
        "Themes": "crushing fork opening short",
        "GameUrl": "https://lichess.org/56Atk60f#20",
        "OpeningTags": "Richter-Veresov_Attack Richter-Veresov_Attack_Other_variations"
    },
    {
        "PuzzleId": "00ZAn",
        "FEN": "rnbqk1nr/ppp1b1pp/3p4/4p3/2B1P3/5N2/PPPP2PP/RNBQK2R w KQkq - 0 6",
        "Moves": "f3e5 d6e5 d1h5 g7g6 h5e5 g8f6",
        "Rating": 1801,
        "RatingDeviation": 75,
        "Popularity": 84,
        "NbPlays": 139,
        "Themes": "advantage hangingPiece long opening",
        "GameUrl": "https://lichess.org/uS929Njx#10",
        "OpeningTags": "Kings_Gambit Kings_Gambit_Other_variations"
    },
    {
        "PuzzleId": "00ZK8",
        "FEN": "r1bq1b1r/pp3kpp/3p1n2/3Q4/2n1P3/5N2/PP3PPP/RNB1K2R b KQ - 1 10",
        "Moves": "c8e6 f3g5 f7g6 d5e6",
        "Rating": 2380,
        "RatingDeviation": 75,
        "Popularity": 82,
        "NbPlays": 328,
        "Themes": "advantage deflection opening short",
        "GameUrl": "https://lichess.org/NOQlRyAF/black#19",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Old_Sicilian"
    },
    {
        "PuzzleId": "00bmj",
        "FEN": "r2q1k1r/p1p2ppp/1p6/8/3n2b1/1Q3NP1/PP1N1PP1/3RKB1R w K - 2 15",
        "Moves": "b3b4 c7c5 b4c4 d8e7 f1e2 b6b5 c4d3 g4f5 d3d4 c5d4",
        "Rating": 2446,
        "RatingDeviation": 83,
        "Popularity": 38,
        "NbPlays": 94,
        "Themes": "advantage defensiveMove opening pin veryLong",
        "GameUrl": "https://lichess.org/FrYWZCWt#28",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_London_System"
    },
    {
        "PuzzleId": "00d1o",
        "FEN": "r2qk1nr/pbpp1pbp/1p2p1p1/3Pn3/2P1P3/3B1N2/PP3PPP/RNBQ1RK1 w kq - 0 8",
        "Moves": "c1g5 e5f3 d1f3 d8g5",
        "Rating": 1121,
        "RatingDeviation": 84,
        "Popularity": 91,
        "NbPlays": 734,
        "Themes": "crushing kingsideAttack opening short",
        "GameUrl": "https://lichess.org/Twrqm0Jp#14",
        "OpeningTags": "English_Defense English_Defense_Other_variations"
    },
    {
        "PuzzleId": "00isY",
        "FEN": "rnbqkb1r/ppp3pp/5n2/3P1p2/4pB2/2N5/PP3PPP/R2QKBNR b KQkq - 0 7",
        "Moves": "f8b4 d1a4 c7c6 a4b4",
        "Rating": 1434,
        "RatingDeviation": 75,
        "Popularity": 95,
        "NbPlays": 15310,
        "Themes": "crushing fork master opening short",
        "GameUrl": "https://lichess.org/1q2x0Fv6/black#13",
        "OpeningTags": "Blackmar-Diemer_Gambit Blackmar-Diemer_Gambit_Other_variations"
    },
    {
        "PuzzleId": "00k6k",
        "FEN": "r2q1rk1/p1p1bpp1/2p1bn1p/8/2Pp3B/1PNBPP2/P5PP/R2Q1RK1 w - - 0 14",
        "Moves": "e3d4 d8d4 h4f2 d4c3",
        "Rating": 1030,
        "RatingDeviation": 76,
        "Popularity": 84,
        "NbPlays": 194,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/JsKisVgT#26",
        "OpeningTags": "English_Opening English_Opening_Kings_English_Variation"
    },
    {
        "PuzzleId": "00mKK",
        "FEN": "r1bq1k1r/pp3pbp/4Pnp1/nB6/8/2N2N2/PP3PPP/R1BQR1K1 b - - 0 13",
        "Moves": "d8d1 e6e7 f8g8 e1d1",
        "Rating": 1883,
        "RatingDeviation": 75,
        "Popularity": 82,
        "NbPlays": 152,
        "Themes": "advancedPawn crushing intermezzo opening short",
        "GameUrl": "https://lichess.org/8r5AZVRA/black#25",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Accelerated_Panov_Attack"
    },
    {
        "PuzzleId": "00rEz",
        "FEN": "r1bqk2r/ppp2ppp/3p4/4p2n/2PBP2b/5PN1/PP4PP/RN1QKB1R b KQkq - 0 9",
        "Moves": "h5g3 h2g3 h4g3 d4f2 g3f2 e1f2",
        "Rating": 1637,
        "RatingDeviation": 75,
        "Popularity": 93,
        "NbPlays": 1869,
        "Themes": "advantage long opening",
        "GameUrl": "https://lichess.org/KJUAVfza/black#17",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Maroczy_Defense"
    },
    {
        "PuzzleId": "00rva",
        "FEN": "r2qkb1r/pQpbpppp/2n2n2/1N6/2pP4/8/PP2PPPP/R1B1KBNR b KQkq - 2 7",
        "Moves": "a8b8 b5c7 d8c7 b7c7",
        "Rating": 1021,
        "RatingDeviation": 76,
        "Popularity": 96,
        "NbPlays": 9202,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/14QnOxb7/black#13",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Marshall_Defense"
    },
    {
        "PuzzleId": "00s16",
        "FEN": "rBbqk2r/1p3ppp/p3pn2/8/1b1P4/2N2N1P/PP3PP1/R2QKB1R b KQkq - 0 10",
        "Moves": "a8b8 d1a4 b7b5 a4b4",
        "Rating": 1135,
        "RatingDeviation": 82,
        "Popularity": 91,
        "NbPlays": 743,
        "Themes": "crushing fork opening short",
        "GameUrl": "https://lichess.org/sflO7yGm/black#19",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Panov_Attack"
    },
    {
        "PuzzleId": "00s23",
        "FEN": "r2q1rk1/1ppb1ppp/1p1p1n2/4p3/1PBnP3/P2P1N1P/2P2PP1/R1BQK2R w KQ - 0 11",
        "Moves": "c2c3 d7a4 c3d4 a4d1",
        "Rating": 1823,
        "RatingDeviation": 75,
        "Popularity": 74,
        "NbPlays": 177,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/5BuuOtXQ#20",
        "OpeningTags": "Four_Knights_Game Four_Knights_Game_Italian_Variation"
    },
    {
        "PuzzleId": "00sMF",
        "FEN": "r1bqr1k1/p4pPp/2p1p3/2bpn2Q/8/2NB4/PPP3PP/R1B2R1K b - - 2 15",
        "Moves": "e5d3 h5f7",
        "Rating": 844,
        "RatingDeviation": 82,
        "Popularity": 96,
        "NbPlays": 134,
        "Themes": "kingsideAttack mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/A0iotLWB/black#29",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Closed"
    },
    {
        "PuzzleId": "00sys",
        "FEN": "r1bq1r2/pp2b1pk/2n1pp2/3p4/2pP3N/2P1P1P1/PP1N1PP1/R2QK2R b KQ - 0 13",
        "Moves": "d8e8 h4g6 h7g8 h1h8 g8f7 d1h5",
        "Rating": 2455,
        "RatingDeviation": 79,
        "Popularity": 88,
        "NbPlays": 279,
        "Themes": "crushing discoveredAttack long opening",
        "GameUrl": "https://lichess.org/oeasr2cR/black#25",
        "OpeningTags": "Indian_Defense Indian_Defense_London_System"
    },
    {
        "PuzzleId": "00tdc",
        "FEN": "r1bqk1nr/ppppbppp/2n5/8/2P5/4Q3/PP2PPPP/RNB1KBNR w KQkq - 3 5",
        "Moves": "e3c3 e7b4 c1d2 b4c3",
        "Rating": 1025,
        "RatingDeviation": 82,
        "Popularity": 62,
        "NbPlays": 106,
        "Themes": "crushing opening pin short",
        "GameUrl": "https://lichess.org/u6d3aV84#8",
        "OpeningTags": "English_Opening English_Opening_Kings_English_Variation"
    },
    {
        "PuzzleId": "00u3b",
        "FEN": "rn2kb1r/pbqp1ppp/1p2p3/3nP3/2BP4/5N2/PP2QPPP/RNB1K2R w KQkq - 0 9",
        "Moves": "b1c3 d5c3 b2c3 b6b5 a1b1 b5c4",
        "Rating": 2233,
        "RatingDeviation": 79,
        "Popularity": 90,
        "NbPlays": 1049,
        "Themes": "crushing long opening",
        "GameUrl": "https://lichess.org/hg1xugvX#16",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Alapin_Variation"
    },
    {
        "PuzzleId": "00vf5",
        "FEN": "r1b1kbnr/1pqp1ppp/p1n1p3/8/2BNP3/P1N5/1PP2PPP/R1BQK2R b KQkq - 0 7",
        "Moves": "g8e7 d4b5 a6b5 c3b5 c7b8 b5d6",
        "Rating": 2171,
        "RatingDeviation": 81,
        "Popularity": 91,
        "NbPlays": 1102,
        "Themes": "crushing long opening sacrifice",
        "GameUrl": "https://lichess.org/DaGWQ4jB/black#13",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Closed"
    },
    {
        "PuzzleId": "00w0g",
        "FEN": "rn2kbnr/pp2pp1p/1q2b1p1/3pP3/N2P4/5N2/PP3PPP/R1BQKB1R b KQkq - 3 8",
        "Moves": "b6b4 c1d2 b4a4 d1a4",
        "Rating": 1740,
        "RatingDeviation": 83,
        "Popularity": 48,
        "NbPlays": 59,
        "Themes": "crushing defensiveMove opening short trappedPiece",
        "GameUrl": "https://lichess.org/iHooJN4n/black#15",
        "OpeningTags": "Slav_Defense Slav_Defense_Diemer_Gambit"
    },
    {
        "PuzzleId": "00w6f",
        "FEN": "rnb1r1k1/pp1p1ppp/1q2pn2/1N6/4P3/B1P2P2/P1P3PP/R2QKB1R w KQ - 5 10",
        "Moves": "b5d6 b6e3 f1e2 e3c3",
        "Rating": 1086,
        "RatingDeviation": 77,
        "Popularity": 87,
        "NbPlays": 149,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/1P7Nda81#18",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Pin_Variation"
    },
    {
        "PuzzleId": "00wPZ",
        "FEN": "r1b2rk1/ppp2ppp/8/1B1pN3/3bn3/8/PPP2qPP/RNBQR2K w - - 0 12",
        "Moves": "e5f3 f2g1 f3g1 e4f2",
        "Rating": 1466,
        "RatingDeviation": 87,
        "Popularity": 86,
        "NbPlays": 2514,
        "Themes": "kingsideAttack mate mateIn2 opening sacrifice short smotheredMate",
        "GameUrl": "https://lichess.org/XAwlqpwf#22",
        "OpeningTags": "Italian_Game Italian_Game_Two_Knights_Defense"
    },
    {
        "PuzzleId": "00xsd",
        "FEN": "r1bqkb1r/1p1npp1p/p2p1np1/6B1/3N4/3BP3/PPP2PPP/RN1QK2R w KQkq - 0 8",
        "Moves": "c2c4 d8a5 b1c3 a5g5",
        "Rating": 1177,
        "RatingDeviation": 80,
        "Popularity": 92,
        "NbPlays": 1499,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/bMxAVfzo#14",
        "OpeningTags": "Zukertort_Opening Zukertort_Opening_Sicilian_Invitation"
    },
    {
        "PuzzleId": "00zI4",
        "FEN": "r2q1rk1/pb3ppp/1p2p3/2nn4/8/P1N1PN2/1P1Q1PPP/1BR1K2R b K - 1 13",
        "Moves": "c5b3 d2c2 g7g6 c2b3",
        "Rating": 1808,
        "RatingDeviation": 76,
        "Popularity": 93,
        "NbPlays": 774,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/z6EaD3I9/black#25",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Other_variations"
    },
    {
        "PuzzleId": "00zNz",
        "FEN": "r1bqk2r/pp1np1bp/2p3p1/3pNB2/3P1B2/4P3/PPP2PPP/R2QK2R b KQkq - 0 10",
        "Moves": "g6f5 d1h5 e8f8 h5f7",
        "Rating": 1121,
        "RatingDeviation": 76,
        "Popularity": 95,
        "NbPlays": 3974,
        "Themes": "mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/kZTBqbqj/black#19",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Accelerated_London_System"
    },
    {
        "PuzzleId": "0103M",
        "FEN": "2kr1b1r/pppb1p1p/1q6/4p3/1P1n4/2P1BN2/5PPP/R2QKB1R w KQ - 2 16",
        "Moves": "c3d4 e5d4 d1d4 f8b4",
        "Rating": 2182,
        "RatingDeviation": 87,
        "Popularity": 82,
        "NbPlays": 56,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/lHWulFLi#30",
        "OpeningTags": "Scandinavian_Defense Scandinavian_Defense_Main_Line"
    },
    {
        "PuzzleId": "010Jc",
        "FEN": "rnb1k2r/bpqp1pp1/p3p3/7p/4P1n1/1NNB3P/PPP2PP1/R1BQ1R1K w kq - 1 11",
        "Moves": "d1e2 c7h2",
        "Rating": 651,
        "RatingDeviation": 82,
        "Popularity": 99,
        "NbPlays": 1408,
        "Themes": "master mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/zDw0FRz2#20",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Kan_Variation"
    },
    {
        "PuzzleId": "010ZV",
        "FEN": "r2qk1nr/p1pbb1pp/4p3/2pp1P2/2B5/8/PPP1Q1PP/RNB2RK1 b kq - 0 13",
        "Moves": "d5c4 e2h5 g7g6 f5g6",
        "Rating": 1794,
        "RatingDeviation": 76,
        "Popularity": 90,
        "NbPlays": 221,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/TyuyYtZG/black#25",
        "OpeningTags": "Ruy_Lopez Ruy_Lopez_Steinitz_Defense"
    },
    {
        "PuzzleId": "011A6",
        "FEN": "1r1q1rk1/pb3pbp/1p1pnnp1/1Np5/2P5/PP3NP1/1B3PBP/Q1RR2K1 b - - 5 20",
        "Moves": "d6d5 c4d5",
        "Rating": 1570,
        "RatingDeviation": 77,
        "Popularity": 68,
        "NbPlays": 70,
        "Themes": "advantage oneMove opening",
        "GameUrl": "https://lichess.org/7QbYroZU/black#39",
        "OpeningTags": null
    },
    {
        "PuzzleId": "013h1",
        "FEN": "r1bqk1nr/1p3ppp/p3p3/3pP3/1b1PP3/2N5/PP4PP/R1BQKB1R b KQkq - 0 9",
        "Moves": "d5e4 d1a4 c8d7 a4b4",
        "Rating": 1206,
        "RatingDeviation": 128,
        "Popularity": 83,
        "NbPlays": 28,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/3L3zhonx/black#17",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_McDonnell_Attack"
    },
    {
        "PuzzleId": "015Di",
        "FEN": "r2k1bnr/p1pp1Bpp/1p3q2/4N1B1/3p4/2P5/PP2QPbP/RN2K2R b KQ - 2 10",
        "Moves": "f6g5 e5c6 g2c6 e2e8",
        "Rating": 1631,
        "RatingDeviation": 75,
        "Popularity": 91,
        "NbPlays": 2202,
        "Themes": "clearance mate mateIn2 opening sacrifice short",
        "GameUrl": "https://lichess.org/T3BCr5TM/black#19",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_McConnell_Defense"
    },
    {
        "PuzzleId": "015i1",
        "FEN": "r2q1rk1/pp1bnpp1/2n1p3/2b1P1NQ/3p4/P7/1P3PPP/RNB2RK1 b - - 3 13",
        "Moves": "e7g6 h5h7",
        "Rating": 825,
        "RatingDeviation": 79,
        "Popularity": 77,
        "NbPlays": 118,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/Gk8K5tC9/black#25",
        "OpeningTags": "French_Defense French_Defense_Advance_Variation"
    },
    {
        "PuzzleId": "016BD",
        "FEN": "r1bqk2r/pp4pp/3b1B2/3pNn2/4p3/2N5/PPP2PPP/R2QKB1R b KQkq - 0 11",
        "Moves": "g7f6 d1h5 e8f8 h5f7",
        "Rating": 1710,
        "RatingDeviation": 75,
        "Popularity": 79,
        "NbPlays": 172,
        "Themes": "mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/qzKzWmta/black#21",
        "OpeningTags": "Nimzowitsch_Defense Nimzowitsch_Defense_Kennedy_Variation"
    },
    {
        "PuzzleId": "017Lc",
        "FEN": "r1b2rk1/pp3ppp/2p1pn2/8/2P5/n5Q1/PP1BN1PP/Kq1R1B1R w - - 10 22",
        "Moves": "d1b1 a3c2",
        "Rating": 1068,
        "RatingDeviation": 152,
        "Popularity": 83,
        "NbPlays": 11,
        "Themes": "opening",
        "GameUrl": "https://lichess.org/VaAPfIHH#42",
        "OpeningTags": null
    },
    {
        "PuzzleId": "017u3",
        "FEN": "r2qk2r/4bppp/p3bn2/1p2N3/5B2/2N5/PP3PPP/R2QR1K1 b kq - 1 19",
        "Moves": "e8g8 e5c6 d8e8 c6e7 e8e7 f4d6 e7d8 d6f8",
        "Rating": 2042,
        "RatingDeviation": 74,
        "Popularity": 94,
        "NbPlays": 5733,
        "Themes": "advantage kingsideAttack opening skewer veryLong",
        "GameUrl": "https://lichess.org/zSJZUzqR/black#37",
        "OpeningTags": "Caro-Kann_Defense Caro-Kann_Defense_Exchange_Variation"
    },
    {
        "PuzzleId": "019DY",
        "FEN": "rnb1k1nB/ppp2p1p/8/8/7q/1P3pb1/P1PPP2P/RN1QKB1R w KQq - 0 9",
        "Moves": "h2g3 h4g3",
        "Rating": 1084,
        "RatingDeviation": 183,
        "Popularity": -67,
        "NbPlays": 7,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/M6zRIUyg#16",
        "OpeningTags": null
    },
    {
        "PuzzleId": "01Az7",
        "FEN": "r1bq1rk1/pp1p1ppp/2n1pn2/4P3/2B5/2B5/PPP2PPP/R2QK1NR b KQ - 0 9",
        "Moves": "c6e5 c3e5 d8a5 e5c3",
        "Rating": 1369,
        "RatingDeviation": 92,
        "Popularity": 74,
        "NbPlays": 37,
        "Themes": "advantage hangingPiece opening short",
        "GameUrl": "https://lichess.org/nMfMTSlO/black#17",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Bowdler_Attack"
    },
    {
        "PuzzleId": "01DHd",
        "FEN": "r1bq1rk1/pp1nb1pp/4pp2/3pP2Q/2pP4/2P1P3/PPBN2PP/R1B2RK1 b - - 1 12",
        "Moves": "g7g6 c2g6 h7g6 h5g6",
        "Rating": 1113,
        "RatingDeviation": 75,
        "Popularity": 95,
        "NbPlays": 3676,
        "Themes": "crushing kingsideAttack opening short",
        "GameUrl": "https://lichess.org/tYOhhfGL/black#23",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Other_variations"
    },
    {
        "PuzzleId": "01E5s",
        "FEN": "r1b1kbnr/p1ppqppp/8/1p2P3/1n1Q4/5N2/PPP1PPPP/RNB1KB1R w KQkq - 4 8",
        "Moves": "d4e4 d7d5 e4f4 b4c2",
        "Rating": 1751,
        "RatingDeviation": 128,
        "Popularity": 74,
        "NbPlays": 22,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/jBa71LkS#14",
        "OpeningTags": "Englund_Gambit_Complex Englund_Gambit_Complex_Stockholm_Variation"
    },
    {
        "PuzzleId": "01EUl",
        "FEN": "r2qk2r/ppp2pp1/2p2n2/7p/3bP1b1/2N3Q1/PPP2PPP/R1B1KB1R w KQkq - 0 9",
        "Moves": "h2h3 d4c3 g3c3 d8d1",
        "Rating": 1319,
        "RatingDeviation": 77,
        "Popularity": 96,
        "NbPlays": 27062,
        "Themes": "clearance mate mateIn2 opening short",
        "GameUrl": "https://lichess.org/eR5rGPfR#16",
        "OpeningTags": "Russian_Game Russian_Game_Stafford_Gambit"
    },
    {
        "PuzzleId": "01F7L",
        "FEN": "r3kb1r/ppp2ppp/8/2p1Pb2/3Pn2q/3B1P2/PPP3PP/RNBQK2R w KQkq - 1 9",
        "Moves": "e1e2 h4f2",
        "Rating": 928,
        "RatingDeviation": 75,
        "Popularity": 86,
        "NbPlays": 238,
        "Themes": "mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/bHxdc27g#16",
        "OpeningTags": "Russian_Game Russian_Game_Stafford_Gambit"
    },
    {
        "PuzzleId": "01HAq",
        "FEN": "rn1q1rk1/1bppppbp/1p4pn/6N1/p1B1P3/2PP3Q/PP3PPP/RNB1K2R w KQ - 0 9",
        "Moves": "c4f7 f8f7 g5f7 h6f7",
        "Rating": 1886,
        "RatingDeviation": 74,
        "Popularity": 74,
        "NbPlays": 85,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/jjI0oEay#16",
        "OpeningTags": "Owen_Defense Owen_Defense_Other_variations"
    },
    {
        "PuzzleId": "01IFU",
        "FEN": "r1b2rk1/pp3pp1/3b3p/3Bn3/P2N1q2/2P4P/1P3PP1/RN1Q1RK1 w - - 1 17",
        "Moves": "d4e2 e5f3 g2f3 f4h2",
        "Rating": 1086,
        "RatingDeviation": 75,
        "Popularity": 98,
        "NbPlays": 1126,
        "Themes": "kingsideAttack mate mateIn2 opening sacrifice short",
        "GameUrl": "https://lichess.org/0kHqIPwO#32",
        "OpeningTags": "Philidor_Defense Philidor_Defense_Other_variations"
    },
    {
        "PuzzleId": "01L59",
        "FEN": "rnb2rk1/pp1p1ppp/4p3/4P3/3b1Pnq/2N5/PPPNB1PP/R1BQ1R1K w - - 2 12",
        "Moves": "g2g3 h4h2",
        "Rating": 1114,
        "RatingDeviation": 78,
        "Popularity": 94,
        "NbPlays": 1287,
        "Themes": "kingsideAttack mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/5qG1QQrX#22",
        "OpeningTags": "Mieses_Opening Mieses_Opening_Other_variations"
    },
    {
        "PuzzleId": "01Lm4",
        "FEN": "r3k1nr/2pp1pp1/npbbp1q1/7p/2PP3B/2N1PN1P/PP3PP1/2RQKB1R w Kkq - 3 12",
        "Moves": "f1d3 g6g2 h1g1 g2f3 d1f3 c6f3",
        "Rating": 1740,
        "RatingDeviation": 79,
        "Popularity": 80,
        "NbPlays": 50,
        "Themes": "advantage long opening",
        "GameUrl": "https://lichess.org/ZBLlFmFC#22",
        "OpeningTags": "English_Defense English_Defense_Other_variations"
    },
    {
        "PuzzleId": "01NZ8",
        "FEN": "r1b1kb1r/pp3ppp/4p3/qNpn4/8/P2Q2B1/1PP2PPP/1K1R2NR b kq - 0 13",
        "Moves": "c8d7 b5c7 a5c7 g3c7",
        "Rating": 1028,
        "RatingDeviation": 166,
        "Popularity": -4,
        "NbPlays": 10,
        "Themes": "crushing fork opening short",
        "GameUrl": "https://lichess.org/q5tbSjgO/black#25",
        "OpeningTags": "French_Defense French_Defense_Schlechter_Variation"
    },
    {
        "PuzzleId": "01Prl",
        "FEN": "r1bqn1k1/4prbp/p1p3p1/3p4/5P2/1BN5/PPP3PP/R1BQR1K1 b - - 1 14",
        "Moves": "d8c7 c3d5 c6d5 d1d5 e7e6 d5a8",
        "Rating": 2174,
        "RatingDeviation": 74,
        "Popularity": 93,
        "NbPlays": 4443,
        "Themes": "crushing long opening",
        "GameUrl": "https://lichess.org/2sPwGlma/black#27",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Dragon_Variation"
    },
    {
        "PuzzleId": "01Suf",
        "FEN": "r1bqk1nr/pp3ppp/2nbp3/1Bp5/3pP3/5NN1/PPPP1PPP/R1BQK2R w KQkq - 4 7",
        "Moves": "d2d3 d8a5 f3d2 a5b5",
        "Rating": 1262,
        "RatingDeviation": 74,
        "Popularity": 91,
        "NbPlays": 1051,
        "Themes": "crushing fork opening short",
        "GameUrl": "https://lichess.org/BfscjGsT#12",
        "OpeningTags": "French_Defense French_Defense_Two_Knights_Variation"
    },
    {
        "PuzzleId": "01TmZ",
        "FEN": "r1b2rk1/1p2bppp/pqnp4/3Np3/2B1PP2/PN6/1PP2nPP/R1BQ1R1K w - - 5 13",
        "Moves": "h1g1 f2h3 g1h1 b6g1 f1g1 h3f2",
        "Rating": 1251,
        "RatingDeviation": 81,
        "Popularity": 87,
        "NbPlays": 3738,
        "Themes": "doubleCheck kingsideAttack long mate mateIn3 opening sacrifice smotheredMate",
        "GameUrl": "https://lichess.org/RIwXCRjL#24",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Najdorf_Variation"
    },
    {
        "PuzzleId": "01UQI",
        "FEN": "r3kb1r/1p2pppp/pqnp4/3P4/B3n1b1/5N2/PP1B1PPP/RN1QK2R w KQkq - 0 11",
        "Moves": "d5c6 b6f2",
        "Rating": 1389,
        "RatingDeviation": 94,
        "Popularity": 55,
        "NbPlays": 62,
        "Themes": "attackingF2F7 mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/Qnh7qhgq#20",
        "OpeningTags": "Sicilian_Defense Sicilian_Defense_Modern_Variations"
    },
    {
        "PuzzleId": "01UXl",
        "FEN": "r1bqkb1r/pp4pp/2n1pn2/2p2p2/Q1P5/3P2P1/PP1P1PBP/R1BNK1NR b KQkq - 0 9",
        "Moves": "d8d3 g2c6 b7c6 a4c6 d3d7 c6a8",
        "Rating": 930,
        "RatingDeviation": 95,
        "Popularity": 93,
        "NbPlays": 1141,
        "Themes": "advantage exposedKing fork long opening",
        "GameUrl": "https://lichess.org/WP6oYrOE/black#17",
        "OpeningTags": "English_Opening English_Opening_Symmetrical_Variation"
    },
    {
        "PuzzleId": "01WLY",
        "FEN": "r2qk2r/ppp1npbp/3p2p1/4n3/2P1P3/2N2BB1/PP3PPP/R2QK2R b KQkq - 0 10",
        "Moves": "e5c4 d1a4 e7c6 a4c4",
        "Rating": 1363,
        "RatingDeviation": 77,
        "Popularity": 79,
        "NbPlays": 168,
        "Themes": "crushing fork master opening short",
        "GameUrl": "https://lichess.org/CCJq2aBi/black#19",
        "OpeningTags": "Modern_Defense Modern_Defense_Other_variations"
    },
    {
        "PuzzleId": "01XsQ",
        "FEN": "r2qk2r/ppp1bppp/2n1pn2/2Pp1b2/3P4/P1NBPN2/1P3PPP/R1BQK2R b KQkq - 2 8",
        "Moves": "b7b6 d3b5 e8g8 b5c6",
        "Rating": 1674,
        "RatingDeviation": 78,
        "Popularity": 59,
        "NbPlays": 113,
        "Themes": "advantage opening pin short",
        "GameUrl": "https://lichess.org/iJgr31eL/black#15",
        "OpeningTags": "Queens_Pawn_Game Queens_Pawn_Game_Symmetrical_Variation"
    },
    {
        "PuzzleId": "01Y7w",
        "FEN": "r2q1rk1/pppb1pbp/2n1pnp1/1BPpB3/3P4/4PN2/PP3PPP/RN1QK2R w KQ - 3 9",
        "Moves": "e1g1 c6e5 d4e5 d7b5",
        "Rating": 1470,
        "RatingDeviation": 75,
        "Popularity": 86,
        "NbPlays": 315,
        "Themes": "advantage discoveredAttack opening short",
        "GameUrl": "https://lichess.org/DSv0iSi2#16",
        "OpeningTags": "Queens_Gambit_Declined Queens_Gambit_Declined_Other_variations"
    },
    {
        "PuzzleId": "01YNx",
        "FEN": "rn1qkbnr/ppp1ppp1/3p3p/4N3/2B1P1b1/8/PPPP1PPP/RNBQK2R b KQkq - 1 4",
        "Moves": "g4d1 c4f7",
        "Rating": 1216,
        "RatingDeviation": 79,
        "Popularity": 75,
        "NbPlays": 187,
        "Themes": "attackingF2F7 mate mateIn1 oneMove opening",
        "GameUrl": "https://lichess.org/pyKwuFBH/black#7",
        "OpeningTags": "Zukertort_Opening Zukertort_Opening_Wade_Defense"
    },
    {
        "PuzzleId": "01ZpR",
        "FEN": "2rq1rk1/1p3ppp/p4b2/n6b/3Pp3/P3BN1P/1P2BPP1/2RQ1RK1 w - - 0 18",
        "Moves": "f3d2 c8c1 d1c1 h5e2",
        "Rating": 1544,
        "RatingDeviation": 78,
        "Popularity": 88,
        "NbPlays": 93,
        "Themes": "crushing opening short",
        "GameUrl": "https://lichess.org/DHFroHMk#34",
        "OpeningTags": "Russian_Game Russian_Game_Classical_Attack"
    },
    {
        "PuzzleId": "01cpv",
        "FEN": "r2q1rk1/ppp1bppp/3p1nb1/8/2PpP1PN/P2P3P/1P2BP2/RN1Q1RK1 b - - 1 12",
        "Moves": "f6e4 h4g6 f7g6 d3e4",
        "Rating": 1598,
        "RatingDeviation": 78,
        "Popularity": 82,
        "NbPlays": 70,
        "Themes": "advantage intermezzo opening short",
        "GameUrl": "https://lichess.org/UOdB3Yaf/black#23",
        "OpeningTags": "Kings_Pawn_Game Kings_Pawn_Game_Leonardis_Variation"
    },
    {
        "PuzzleId": "01gkL",
        "FEN": "r1b2bkr/ppp2Np1/3pPq1p/4n3/3Q4/8/PPP2PPP/RNB1K2R w KQ - 2 12",
        "Moves": "f7h8 e5f3 g2f3 f6d4",
        "Rating": 1282,
        "RatingDeviation": 76,
        "Popularity": 91,
        "NbPlays": 3963,
        "Themes": "crushing discoveredAttack opening short",
        "GameUrl": "https://lichess.org/e9vKK71P#22",
        "OpeningTags": "Scotch_Game Scotch_Game_Scotch_Gambit"
    },
    {
        "PuzzleId": "01gnW",
        "FEN": "r2qkb1r/pb1p2pp/1p1Ppn2/1Np1N3/2P5/8/PP3PPP/R2QKB1R b KQkq - 0 12",
        "Moves": "g7g6 b5c7 d8c7 d6c7",
        "Rating": 1135,
        "RatingDeviation": 85,
        "Popularity": 69,
        "NbPlays": 82,
        "Themes": "advancedPawn crushing fork opening short",
        "GameUrl": "https://lichess.org/jyAsTq1X/black#23",
        "OpeningTags": "French_Defense French_Defense_Franco-Sicilian_Defense"
    },
    {
        "PuzzleId": "01hqi",
        "FEN": "r1b2rk1/pp2bppp/1qn1pn2/3pN3/3P1P2/3BP3/PP1N2PP/R1BQ1RK1 b - - 4 10",
        "Moves": "c6d4 e3d4 b6d4 g1h1",
        "Rating": 1783,
        "RatingDeviation": 82,
        "Popularity": 67,
        "NbPlays": 36,
        "Themes": "advantage opening short",
        "GameUrl": "https://lichess.org/qCVvt9s6/black#19",
        "OpeningTags": "Indian_Defense Indian_Defense_Other_variations"
    },
    {
        "PuzzleId": "01i25",
        "FEN": "r2q1rk1/pbp2ppp/1pnbpn2/3pN3/3P4/2P1P1B1/PP1NBPPP/R2QK2R b KQ - 3 9",
        "Moves": "c6e5 d4e5 d6e7 e5f6",
        "Rating": 1263,
        "RatingDeviation": 77,
        "Popularity": 85,
        "NbPlays": 359,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/bQi4COjS/black#17",
        "OpeningTags": "Indian_Defense Indian_Defense_Other_variations"
    },
    {
        "PuzzleId": "01lBL",
        "FEN": "r3kb1r/ppqn1ppp/2p1p1b1/3p4/2PPn3/1PNBPN2/PB3PPP/R2Q1RK1 w kq - 3 10",
        "Moves": "c3e4 d5e4 d3e4 g6e4",
        "Rating": 1271,
        "RatingDeviation": 84,
        "Popularity": 86,
        "NbPlays": 37,
        "Themes": "advantage fork opening short",
        "GameUrl": "https://lichess.org/wO0acWav#18",
        "OpeningTags": "Slav_Defense Slav_Defense_Quiet_Variation"
    }
];
